/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * JINGLE — Christmas scavenger hunt API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptInviteRequest,
  AcceptedInvite,
  AddFounderOperatorRequest,
  AddFounderOperatorResp,
  AdminClueRow,
  AdminFamily,
  AdminFindOk,
  AdminInvitationOk,
  AdminInvite,
  AdminLaunchpad,
  AdminMember,
  AdminMembershipOk,
  AdminResetPasswordResponse,
  AdminState,
  AdvanceDayRequest,
  ApproveAllMissionControlClues200,
  ArchiveMissionControlRecap200,
  Aurora,
  ChangePasswordRequest,
  CheckHostEmailRequest,
  CheckHostEmailResponse,
  ClearMissionControlClueRevisions200,
  CreateBetaRequest,
  CreateGiftClaimRequest,
  CreateWishRequest,
  CreatedBetaFamily,
  DeleteAdminFindRequest,
  DeleteMissionControlClueRevision200,
  DeletionRequestBody,
  DeletionRequestResponse,
  EditClueBody,
  EditMissionControlNarrative200,
  EditMissionControlRecap200,
  EditNarrativeBody,
  Elf,
  ElfAssignment,
  ErrorEnvelope,
  FamilyElfRoster,
  FamilyRecapResponse,
  Find,
  FindResult,
  FounderAlertConfigResp,
  FounderOperatorsResp,
  GameState,
  GenerateMissionControlRecap201,
  GetHubCurrentParams,
  GetLegalRequiredPoliciesParams,
  GetNotificationPushPublicKey200,
  GiftClaim,
  GiftClaimWithWish,
  GiftWorkshopOverview,
  GiftWorkshopState,
  HealthStatus,
  HostAnnouncementCreateRequest,
  HostRecapResponse,
  HubCurrent,
  HubFeedItem,
  Hunt,
  HuntDetail,
  InAppNotification,
  InAppNotificationList,
  InboxMessage,
  InvitePreview,
  JoinRequest,
  LaunchUpdateLeadRequest,
  LegalAcceptancesRequest,
  LegalRequiredPoliciesResponse,
  LegalStatusResponse,
  ListActiveHuntsParams,
  ListInAppNotificationsParams,
  ListInboxParams,
  ListMapFindsParams,
  ListMissionControlClueRevisions200,
  ListMyFindsParams,
  ListMyWishesParams,
  ListPostcardsParams,
  LoginRequest,
  MapFind,
  MarkAllInAppNotificationsRead200,
  MemberWishList,
  MintAdminInvitationRequest,
  MintedAdminInvitation,
  MissionBuilderInputs,
  MissionControlDraft,
  MissionGenerateResponse,
  MissionGenerationRun,
  MissionNarrative,
  Moment,
  NotificationPreferences,
  OkResp,
  PasswordResetRequestBody,
  PasswordResetVerifyBody,
  PasswordResetVerifyResponse,
  Postcard,
  PublishMissionControlRecap200,
  PushSubscribeNativeRequest,
  PushSubscribeRequest,
  RecapPatchBody,
  RecordLegalAcceptances200,
  RemoveAdminMemberRequest,
  ReorderWishesRequest,
  RequestPasswordReset200,
  ReviseClueBody,
  ReviseClueResponse,
  ReviseRateLimitedError,
  SeedElfMessageRequest,
  Session,
  SetAdminMemberRoleRequest,
  SpeakRequest,
  StoryPackPatchBody,
  StoryPackPatchResponse,
  SubmitFindRequest,
  SubscribePush201,
  SubscribePushNative201,
  Team,
  TeamDetail,
  TestSendSelf200,
  TriggerMomentRequest,
  UnsubscribePush200,
  UnsubscribePushNative200,
  UnsubscribePushNativeRequest,
  UnsubscribePushRequest,
  UpdateFounderAlertConfigRequest,
  UpdateGiftClaimRequest,
  UpdateNotificationPreferencesRequest,
  UpdateWishRequest,
  UpdateWorkshopWishRequest,
  UploadUrlRequest,
  UploadUrlResponse,
  UseMissionControlStarter200,
  Wish,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Public endpoint — no auth required. Accepts a lead from the marketing
launch-updates form. Validates email format, rejects honeypot hits,
enforces per-IP rate limit, rejects duplicate emails (409), and stores
the lead in Postgres. Returns 201 on success.
Children's data must never be submitted — the form has no age field.

 * @summary Submit a launch-updates lead
 */
export const getSubmitLaunchUpdateLeadUrl = () => {
  return `/api/launch-updates`;
};

export const submitLaunchUpdateLead = async (
  launchUpdateLeadRequest: LaunchUpdateLeadRequest,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getSubmitLaunchUpdateLeadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(launchUpdateLeadRequest),
  });
};

export const getSubmitLaunchUpdateLeadMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitLaunchUpdateLead>>,
    TError,
    { data: BodyType<LaunchUpdateLeadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitLaunchUpdateLead>>,
  TError,
  { data: BodyType<LaunchUpdateLeadRequest> },
  TContext
> => {
  const mutationKey = ["submitLaunchUpdateLead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitLaunchUpdateLead>>,
    { data: BodyType<LaunchUpdateLeadRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return submitLaunchUpdateLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitLaunchUpdateLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitLaunchUpdateLead>>
>;
export type SubmitLaunchUpdateLeadMutationBody =
  BodyType<LaunchUpdateLeadRequest>;
export type SubmitLaunchUpdateLeadMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Submit a launch-updates lead
 */
export const useSubmitLaunchUpdateLead = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitLaunchUpdateLead>>,
    TError,
    { data: BodyType<LaunchUpdateLeadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitLaunchUpdateLead>>,
  TError,
  { data: BodyType<LaunchUpdateLeadRequest> },
  TContext
> => {
  return useMutation(getSubmitLaunchUpdateLeadMutationOptions(options));
};

/**
 * Public endpoint — no auth required. Accepts a privacy
data-deletion or account-closure request from the legal pages.
Persists the request, fires an auto-reply email to the requester
with a case reference, and notifies the ops team. Rate limited
per IP.

 * @summary Submit a privacy data-deletion request
 */
export const getSubmitDeletionRequestUrl = () => {
  return `/api/deletion-requests`;
};

export const submitDeletionRequest = async (
  deletionRequestBody: DeletionRequestBody,
  options?: RequestInit,
): Promise<DeletionRequestResponse> => {
  return customFetch<DeletionRequestResponse>(getSubmitDeletionRequestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(deletionRequestBody),
  });
};

export const getSubmitDeletionRequestMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitDeletionRequest>>,
    TError,
    { data: BodyType<DeletionRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitDeletionRequest>>,
  TError,
  { data: BodyType<DeletionRequestBody> },
  TContext
> => {
  const mutationKey = ["submitDeletionRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitDeletionRequest>>,
    { data: BodyType<DeletionRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return submitDeletionRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitDeletionRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitDeletionRequest>>
>;
export type SubmitDeletionRequestMutationBody = BodyType<DeletionRequestBody>;
export type SubmitDeletionRequestMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Submit a privacy data-deletion request
 */
export const useSubmitDeletionRequest = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitDeletionRequest>>,
    TError,
    { data: BodyType<DeletionRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitDeletionRequest>>,
  TError,
  { data: BodyType<DeletionRequestBody> },
  TContext
> => {
  return useMutation(getSubmitDeletionRequestMutationOptions(options));
};

/**
 * Returns all current founder operators with display name, username, and
the date each was added. Also returns `currentUserId` so the client can
disable the self-removal button.
Non-founders receive 404 (same as all /api/founder/* routes) so the
route existence is not leaked.

 * @summary List all founder operators (founder-only, 404-cloaked)
 */
export const getListFounderOperatorsUrl = () => {
  return `/api/founder/operators`;
};

export const listFounderOperators = async (
  options?: RequestInit,
): Promise<FounderOperatorsResp> => {
  return customFetch<FounderOperatorsResp>(getListFounderOperatorsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListFounderOperatorsQueryKey = () => {
  return [`/api/founder/operators`] as const;
};

export const getListFounderOperatorsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFounderOperators>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listFounderOperators>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFounderOperatorsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFounderOperators>>
  > = ({ signal }) => listFounderOperators({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFounderOperators>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFounderOperatorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFounderOperators>>
>;
export type ListFounderOperatorsQueryError = ErrorType<void>;

/**
 * @summary List all founder operators (founder-only, 404-cloaked)
 */

export function useListFounderOperators<
  TData = Awaited<ReturnType<typeof listFounderOperators>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listFounderOperators>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFounderOperatorsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Promotes an existing user to founder operator status. The user is
looked up by username (exact match) or email (case-insensitive).
Returns 400 if the identifier is missing, 404 if the user is not
found, 409 if they are already a founder operator.
Non-founders receive 403.
An admin_audit_events row (`founder_operator_added`) is written on
every successful add.

 * @summary Add a founder operator by username or email (founder-only)
 */
export const getAddFounderOperatorUrl = () => {
  return `/api/founder/operators`;
};

export const addFounderOperator = async (
  addFounderOperatorRequest: AddFounderOperatorRequest,
  options?: RequestInit,
): Promise<AddFounderOperatorResp> => {
  return customFetch<AddFounderOperatorResp>(getAddFounderOperatorUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addFounderOperatorRequest),
  });
};

export const getAddFounderOperatorMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addFounderOperator>>,
    TError,
    { data: BodyType<AddFounderOperatorRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addFounderOperator>>,
  TError,
  { data: BodyType<AddFounderOperatorRequest> },
  TContext
> => {
  const mutationKey = ["addFounderOperator"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addFounderOperator>>,
    { data: BodyType<AddFounderOperatorRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return addFounderOperator(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddFounderOperatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof addFounderOperator>>
>;
export type AddFounderOperatorMutationBody =
  BodyType<AddFounderOperatorRequest>;
export type AddFounderOperatorMutationError = ErrorType<void>;

/**
 * @summary Add a founder operator by username or email (founder-only)
 */
export const useAddFounderOperator = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addFounderOperator>>,
    TError,
    { data: BodyType<AddFounderOperatorRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addFounderOperator>>,
  TError,
  { data: BodyType<AddFounderOperatorRequest> },
  TContext
> => {
  return useMutation(getAddFounderOperatorMutationOptions(options));
};

/**
 * Revokes founder operator status for the target user.
Returns 400 if `userId` is not a valid positive integer.
Returns 403 if the caller is not a founder, or if the target userId
equals the caller's own userId (self-removal guard).
Returns 404 if the target is not currently a founder operator.
An admin_audit_events row (`founder_operator_removed`) is written on
every successful removal.

 * @summary Remove a founder operator by userId (founder-only)
 */
export const getRemoveFounderOperatorUrl = (userId: number) => {
  return `/api/founder/operators/${userId}`;
};

export const removeFounderOperator = async (
  userId: number,
  options?: RequestInit,
): Promise<OkResp> => {
  return customFetch<OkResp>(getRemoveFounderOperatorUrl(userId), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveFounderOperatorMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFounderOperator>>,
    TError,
    { userId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeFounderOperator>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationKey = ["removeFounderOperator"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFounderOperator>>,
    { userId: number }
  > = (props) => {
    const { userId } = props ?? {};

    return removeFounderOperator(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveFounderOperatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeFounderOperator>>
>;

export type RemoveFounderOperatorMutationError = ErrorType<void>;

/**
 * @summary Remove a founder operator by userId (founder-only)
 */
export const useRemoveFounderOperator = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFounderOperator>>,
    TError,
    { userId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeFounderOperator>>,
  TError,
  { userId: number },
  TContext
> => {
  return useMutation(getRemoveFounderOperatorMutationOptions(options));
};

/**
 * Returns the effective values used by the nightly founder alert scan
and email/Slack debounce, plus the persisted DB row, env override,
and default for each tunable so the UI can show provenance.
Non-founders receive 404.

 * @summary Read founder alert thresholds + debounce window (founder-only)
 */
export const getGetFounderAlertConfigUrl = () => {
  return `/api/founder/alert-config`;
};

export const getFounderAlertConfig = async (
  options?: RequestInit,
): Promise<FounderAlertConfigResp> => {
  return customFetch<FounderAlertConfigResp>(getGetFounderAlertConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetFounderAlertConfigQueryKey = () => {
  return [`/api/founder/alert-config`] as const;
};

export const getGetFounderAlertConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getFounderAlertConfig>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFounderAlertConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFounderAlertConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFounderAlertConfig>>
  > = ({ signal }) => getFounderAlertConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFounderAlertConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFounderAlertConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFounderAlertConfig>>
>;
export type GetFounderAlertConfigQueryError = ErrorType<void>;

/**
 * @summary Read founder alert thresholds + debounce window (founder-only)
 */

export function useGetFounderAlertConfig<
  TData = Awaited<ReturnType<typeof getFounderAlertConfig>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFounderAlertConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFounderAlertConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Persist a new value for one of the allowlisted founder alert
tunables. Writes an `admin_audit_events` row
(`founder_alert_config_updated`) on every successful update.
Returns the new effective config.

 * @summary Update one founder alert tunable (founder-only)
 */
export const getUpdateFounderAlertConfigUrl = () => {
  return `/api/founder/alert-config`;
};

export const updateFounderAlertConfig = async (
  updateFounderAlertConfigRequest: UpdateFounderAlertConfigRequest,
  options?: RequestInit,
): Promise<FounderAlertConfigResp> => {
  return customFetch<FounderAlertConfigResp>(getUpdateFounderAlertConfigUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateFounderAlertConfigRequest),
  });
};

export const getUpdateFounderAlertConfigMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFounderAlertConfig>>,
    TError,
    { data: BodyType<UpdateFounderAlertConfigRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFounderAlertConfig>>,
  TError,
  { data: BodyType<UpdateFounderAlertConfigRequest> },
  TContext
> => {
  const mutationKey = ["updateFounderAlertConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFounderAlertConfig>>,
    { data: BodyType<UpdateFounderAlertConfigRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateFounderAlertConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFounderAlertConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFounderAlertConfig>>
>;
export type UpdateFounderAlertConfigMutationBody =
  BodyType<UpdateFounderAlertConfigRequest>;
export type UpdateFounderAlertConfigMutationError = ErrorType<void>;

/**
 * @summary Update one founder alert tunable (founder-only)
 */
export const useUpdateFounderAlertConfig = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFounderAlertConfig>>,
    TError,
    { data: BodyType<UpdateFounderAlertConfigRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFounderAlertConfig>>,
  TError,
  { data: BodyType<UpdateFounderAlertConfigRequest> },
  TContext
> => {
  return useMutation(getUpdateFounderAlertConfigMutationOptions(options));
};

/**
 * Founder-only. Returns all launch-updates leads as a CSV file suitable
for import into MailerLite, ConvertKit, or a spreadsheet. Non-founders
receive 404 (same as all /api/founder/* routes) so the route existence
is not leaked.

 * @summary Export launch-updates leads as CSV (founder only)
 */
export const getExportLaunchUpdateLeadsUrl = () => {
  return `/api/founder/launch-updates-leads/export`;
};

export const exportLaunchUpdateLeads = async (
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getExportLaunchUpdateLeadsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportLaunchUpdateLeadsQueryKey = () => {
  return [`/api/founder/launch-updates-leads/export`] as const;
};

export const getExportLaunchUpdateLeadsQueryOptions = <
  TData = Awaited<ReturnType<typeof exportLaunchUpdateLeads>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportLaunchUpdateLeads>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportLaunchUpdateLeadsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportLaunchUpdateLeads>>
  > = ({ signal }) => exportLaunchUpdateLeads({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportLaunchUpdateLeads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportLaunchUpdateLeadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportLaunchUpdateLeads>>
>;
export type ExportLaunchUpdateLeadsQueryError = ErrorType<void>;

/**
 * @summary Export launch-updates leads as CSV (founder only)
 */

export function useExportLaunchUpdateLeads<
  TData = Awaited<ReturnType<typeof exportLaunchUpdateLeads>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportLaunchUpdateLeads>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportLaunchUpdateLeadsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Request a presigned URL for file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponse> => {
  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary Serve a public asset
 */
export const getGetPublicObjectUrl = (filePath: string) => {
  return `/api/storage/public-objects/${filePath}`;
};

export const getPublicObject = async (
  filePath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetPublicObjectUrl(filePath), {
    ...options,
    method: "GET",
  });
};

export const getGetPublicObjectQueryKey = (filePath: string) => {
  return [`/api/storage/public-objects/${filePath}`] as const;
};

export const getGetPublicObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  filePath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({
    signal,
  }) => getPublicObject(filePath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!filePath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicObject>>
>;
export type GetPublicObjectQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Serve a public asset
 */

export function useGetPublicObject<
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  filePath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPublicObjectQueryOptions(filePath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Serve an object entity
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Serve an object entity
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Join a team using an invite code (legacy)
 */
export const getJoinSessionUrl = () => {
  return `/api/session/join`;
};

export const joinSession = async (
  joinRequest: JoinRequest,
  options?: RequestInit,
): Promise<Session> => {
  return customFetch<Session>(getJoinSessionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(joinRequest),
  });
};

export const getJoinSessionMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinSession>>,
    TError,
    { data: BodyType<JoinRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof joinSession>>,
  TError,
  { data: BodyType<JoinRequest> },
  TContext
> => {
  const mutationKey = ["joinSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof joinSession>>,
    { data: BodyType<JoinRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return joinSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type JoinSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof joinSession>>
>;
export type JoinSessionMutationBody = BodyType<JoinRequest>;
export type JoinSessionMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Join a team using an invite code (legacy)
 */
export const useJoinSession = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof joinSession>>,
    TError,
    { data: BodyType<JoinRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof joinSession>>,
  TError,
  { data: BodyType<JoinRequest> },
  TContext
> => {
  return useMutation(getJoinSessionMutationOptions(options));
};

/**
 * @summary Log in with username and password
 */
export const getLoginSessionUrl = () => {
  return `/api/session/login`;
};

export const loginSession = async (
  loginRequest: LoginRequest,
  options?: RequestInit,
): Promise<Session> => {
  return customFetch<Session>(getLoginSessionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginRequest),
  });
};

export const getLoginSessionMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginSession>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginSession>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationKey = ["loginSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginSession>>,
    { data: BodyType<LoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return loginSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginSession>>
>;
export type LoginSessionMutationBody = BodyType<LoginRequest>;
export type LoginSessionMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Log in with username and password
 */
export const useLoginSession = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginSession>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof loginSession>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  return useMutation(getLoginSessionMutationOptions(options));
};

/**
 * @summary Change the current user's password (also clears the must-reset flag)
 */
export const getChangePasswordUrl = () => {
  return `/api/session/change-password`;
};

export const changePassword = async (
  changePasswordRequest: ChangePasswordRequest,
  options?: RequestInit,
): Promise<Session> => {
  return customFetch<Session>(getChangePasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changePasswordRequest),
  });
};

export const getChangePasswordMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: BodyType<ChangePasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: BodyType<ChangePasswordRequest> },
  TContext
> => {
  const mutationKey = ["changePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePassword>>,
    { data: BodyType<ChangePasswordRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return changePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePassword>>
>;
export type ChangePasswordMutationBody = BodyType<ChangePasswordRequest>;
export type ChangePasswordMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Change the current user's password (also clears the must-reset flag)
 */
export const useChangePassword = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: BodyType<ChangePasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: BodyType<ChangePasswordRequest> },
  TContext
> => {
  return useMutation(getChangePasswordMutationOptions(options));
};

/**
 * Public endpoint. Always returns `{ ok: true }` regardless of whether
the identifier matches a known user — this prevents account
enumeration. The response is intentionally generic and the real work
(DB lookup + email send) happens asynchronously after the response is
sent so timing is uniform across all branches.

 * @summary Request a password reset code via email
 */
export const getRequestPasswordResetUrl = () => {
  return `/api/session/password-reset/request`;
};

export const requestPasswordReset = async (
  passwordResetRequestBody: PasswordResetRequestBody,
  options?: RequestInit,
): Promise<RequestPasswordReset200> => {
  return customFetch<RequestPasswordReset200>(getRequestPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(passwordResetRequestBody),
  });
};

export const getRequestPasswordResetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetRequestBody> },
  TContext
> => {
  const mutationKey = ["requestPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    { data: BodyType<PasswordResetRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestPasswordReset>>
>;
export type RequestPasswordResetMutationBody =
  BodyType<PasswordResetRequestBody>;
export type RequestPasswordResetMutationError = ErrorType<unknown>;

/**
 * @summary Request a password reset code via email
 */
export const useRequestPasswordReset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetRequestBody> },
  TContext
> => {
  return useMutation(getRequestPasswordResetMutationOptions(options));
};

/**
 * Public endpoint. Validates the one-time code and rotates the user's
password. On success the server drops a fresh session cookie. All
failure modes (bad code, expired, identifier mismatch) surface a
generic 400 to avoid enumeration.

 * @summary Redeem a password reset code and set a new password
 */
export const getVerifyPasswordResetUrl = () => {
  return `/api/session/password-reset/verify`;
};

export const verifyPasswordReset = async (
  passwordResetVerifyBody: PasswordResetVerifyBody,
  options?: RequestInit,
): Promise<PasswordResetVerifyResponse> => {
  return customFetch<PasswordResetVerifyResponse>(getVerifyPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(passwordResetVerifyBody),
  });
};

export const getVerifyPasswordResetMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetVerifyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetVerifyBody> },
  TContext
> => {
  const mutationKey = ["verifyPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyPasswordReset>>,
    { data: BodyType<PasswordResetVerifyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return verifyPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyPasswordReset>>
>;
export type VerifyPasswordResetMutationBody = BodyType<PasswordResetVerifyBody>;
export type VerifyPasswordResetMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Redeem a password reset code and set a new password
 */
export const useVerifyPasswordReset = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetVerifyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetVerifyBody> },
  TContext
> => {
  return useMutation(getVerifyPasswordResetMutationOptions(options));
};

/**
 * @summary Get current session and team
 */
export const getGetSessionUrl = () => {
  return `/api/session/me`;
};

export const getSession = async (options?: RequestInit): Promise<Session> => {
  return customFetch<Session>(getGetSessionUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSessionQueryKey = () => {
  return [`/api/session/me`] as const;
};

export const getGetSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getSession>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSession>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSessionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSession>>> = ({
    signal,
  }) => getSession({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSession>>
>;
export type GetSessionQueryError = ErrorType<unknown>;

/**
 * @summary Get current session and team
 */

export function useGetSession<
  TData = Awaited<ReturnType<typeof getSession>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSession>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSessionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Idempotent. Sets `onboarding_complete = true` for the authenticated
user. After this call, `GET /session/me` will return
`needsOnboarding: false` for the same user.

 * @summary Mark the current user as having finished the cinematic onboarding intro
 */
export const getCompleteOnboardingUrl = () => {
  return `/api/session/onboarding-complete`;
};

export const completeOnboarding = async (
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getCompleteOnboardingUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCompleteOnboardingMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeOnboarding>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeOnboarding>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["completeOnboarding"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeOnboarding>>,
    void
  > = () => {
    return completeOnboarding(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteOnboardingMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeOnboarding>>
>;

export type CompleteOnboardingMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Mark the current user as having finished the cinematic onboarding intro
 */
export const useCompleteOnboarding = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeOnboarding>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeOnboarding>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCompleteOnboardingMutationOptions(options));
};

/**
 * @summary Clear session
 */
export const getLogoutSessionUrl = () => {
  return `/api/session/logout`;
};

export const logoutSession = async (options?: RequestInit): Promise<void> => {
  return customFetch<void>(getLogoutSessionUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logoutSession>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logoutSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logoutSession>>,
    void
  > = () => {
    return logoutSession(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof logoutSession>>
>;

export type LogoutSessionMutationError = ErrorType<unknown>;

/**
 * @summary Clear session
 */
export const useLogoutSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logoutSession>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutSessionMutationOptions(options));
};

/**
 * Permanently closes the host's family account. Required by Apple App
Store Review Guideline 5.1.1(v) so users have an in-app path to
request account deletion.

Authorization: only the owner of the active tenant can call this
endpoint. Players, co-hosts ("admin" role), and unauthenticated
callers receive 403/401 respectively. Users can only delete their
OWN account — the active tenant is resolved server-side from the
session cookie, never accepted from the client.

Effect: the tenant is soft-deleted (`deleted_at` is set), all
memberships in the tenant are revoked so every member is locked
out on their next request, the team epoch is bumped to invalidate
existing session cookies, and the caller's session cookie is
cleared. Backups are purged within 30 days per the Privacy Policy.

 * @summary Self-serve account deletion (owner only)
 */
export const getDeleteOwnAccountUrl = () => {
  return `/api/account`;
};

export const deleteOwnAccount = async (
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteOwnAccountUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteOwnAccountMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOwnAccount>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOwnAccount>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteOwnAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOwnAccount>>,
    void
  > = () => {
    return deleteOwnAccount(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOwnAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOwnAccount>>
>;

export type DeleteOwnAccountMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Self-serve account deletion (owner only)
 */
export const useDeleteOwnAccount = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOwnAccount>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOwnAccount>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteOwnAccountMutationOptions(options));
};

/**
 * @summary List all teams
 */
export const getListTeamsUrl = () => {
  return `/api/teams`;
};

export const listTeams = async (options?: RequestInit): Promise<Team[]> => {
  return customFetch<Team[]>(getListTeamsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTeamsQueryKey = () => {
  return [`/api/teams`] as const;
};

export const getListTeamsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTeamsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeams>>> = ({
    signal,
  }) => listTeams({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTeams>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTeamsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTeams>>
>;
export type ListTeamsQueryError = ErrorType<unknown>;

/**
 * @summary List all teams
 */

export function useListTeams<
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTeamsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get current team detail
 */
export const getGetMyTeamUrl = () => {
  return `/api/teams/me`;
};

export const getMyTeam = async (options?: RequestInit): Promise<TeamDetail> => {
  return customFetch<TeamDetail>(getGetMyTeamUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyTeamQueryKey = () => {
  return [`/api/teams/me`] as const;
};

export const getGetMyTeamQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyTeam>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyTeam>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyTeamQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyTeam>>> = ({
    signal,
  }) => getMyTeam({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyTeam>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyTeamQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyTeam>>
>;
export type GetMyTeamQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Get current team detail
 */

export function useGetMyTeam<
  TData = Awaited<ReturnType<typeof getMyTeam>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyTeam>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyTeamQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the caller's deterministic elf assignment for the active
tenant. If the caller does not yet have an assignment, one is
created on the fly using the deterministic algorithm described in
`ELF_LIBRARY_AND_ASSIGNMENT_REPORT.md`. Tenant-scoped: the active
tenant is resolved server-side from the session — never from the
client.

 * @summary Read (and lazily create) the caller's elf assignment in the active tenant
 */
export const getGetMyElfAssignmentUrl = () => {
  return `/api/elf-assignments/me`;
};

export const getMyElfAssignment = async (
  options?: RequestInit,
): Promise<ElfAssignment> => {
  return customFetch<ElfAssignment>(getGetMyElfAssignmentUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyElfAssignmentQueryKey = () => {
  return [`/api/elf-assignments/me`] as const;
};

export const getGetMyElfAssignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyElfAssignment>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyElfAssignment>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyElfAssignmentQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyElfAssignment>>
  > = ({ signal }) => getMyElfAssignment({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyElfAssignment>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyElfAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyElfAssignment>>
>;
export type GetMyElfAssignmentQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Read (and lazily create) the caller's elf assignment in the active tenant
 */

export function useGetMyElfAssignment<
  TData = Awaited<ReturnType<typeof getMyElfAssignment>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyElfAssignment>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyElfAssignmentQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the active tenant's full roster with each active member's
elf assignment (or null when none exists yet — this endpoint is
read-only and never auto-creates assignments). Owner/admin
membership role required; players receive 403.

 * @summary Host-only roster of every active member + their elf
 */
export const getGetFamilyElfRosterUrl = () => {
  return `/api/elf-assignments/family`;
};

export const getFamilyElfRoster = async (
  options?: RequestInit,
): Promise<FamilyElfRoster> => {
  return customFetch<FamilyElfRoster>(getGetFamilyElfRosterUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetFamilyElfRosterQueryKey = () => {
  return [`/api/elf-assignments/family`] as const;
};

export const getGetFamilyElfRosterQueryOptions = <
  TData = Awaited<ReturnType<typeof getFamilyElfRoster>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFamilyElfRoster>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFamilyElfRosterQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFamilyElfRoster>>
  > = ({ signal }) => getFamilyElfRoster({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFamilyElfRoster>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFamilyElfRosterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFamilyElfRoster>>
>;
export type GetFamilyElfRosterQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Host-only roster of every active member + their elf
 */

export function useGetFamilyElfRoster<
  TData = Awaited<ReturnType<typeof getFamilyElfRoster>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFamilyElfRoster>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFamilyElfRosterQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all elves
 */
export const getListElvesUrl = () => {
  return `/api/elves`;
};

export const listElves = async (options?: RequestInit): Promise<Elf[]> => {
  return customFetch<Elf[]>(getListElvesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListElvesQueryKey = () => {
  return [`/api/elves`] as const;
};

export const getListElvesQueryOptions = <
  TData = Awaited<ReturnType<typeof listElves>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listElves>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListElvesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listElves>>> = ({
    signal,
  }) => listElves({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listElves>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListElvesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listElves>>
>;
export type ListElvesQueryError = ErrorType<unknown>;

/**
 * @summary List all elves
 */

export function useListElves<
  TData = Awaited<ReturnType<typeof listElves>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listElves>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListElvesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get elf detail
 */
export const getGetElfUrl = (slug: string) => {
  return `/api/elves/${slug}`;
};

export const getElf = async (
  slug: string,
  options?: RequestInit,
): Promise<Elf> => {
  return customFetch<Elf>(getGetElfUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetElfQueryKey = (slug: string) => {
  return [`/api/elves/${slug}`] as const;
};

export const getGetElfQueryOptions = <
  TData = Awaited<ReturnType<typeof getElf>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getElf>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetElfQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getElf>>> = ({
    signal,
  }) => getElf(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getElf>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetElfQueryResult = NonNullable<Awaited<ReturnType<typeof getElf>>>;
export type GetElfQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Get elf detail
 */

export function useGetElf<
  TData = Awaited<ReturnType<typeof getElf>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getElf>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetElfQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Generate TTS audio for an elf line
 */
export const getSpeakElfUrl = (slug: string) => {
  return `/api/elves/${slug}/speak`;
};

export const speakElf = async (
  slug: string,
  speakRequest: SpeakRequest,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getSpeakElfUrl(slug), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(speakRequest),
  });
};

export const getSpeakElfMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speakElf>>,
    TError,
    { slug: string; data: BodyType<SpeakRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof speakElf>>,
  TError,
  { slug: string; data: BodyType<SpeakRequest> },
  TContext
> => {
  const mutationKey = ["speakElf"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof speakElf>>,
    { slug: string; data: BodyType<SpeakRequest> }
  > = (props) => {
    const { slug, data } = props ?? {};

    return speakElf(slug, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SpeakElfMutationResult = NonNullable<
  Awaited<ReturnType<typeof speakElf>>
>;
export type SpeakElfMutationBody = BodyType<SpeakRequest>;
export type SpeakElfMutationError = ErrorType<unknown>;

/**
 * @summary Generate TTS audio for an elf line
 */
export const useSpeakElf = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof speakElf>>,
    TError,
    { slug: string; data: BodyType<SpeakRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof speakElf>>,
  TError,
  { slug: string; data: BodyType<SpeakRequest> },
  TContext
> => {
  return useMutation(getSpeakElfMutationOptions(options));
};

/**
 * Returns the most recent inbox messages, newest first. Optional
`?limit=` (default 50, max 100) caps the page size. Optional
`?cursor=ID` returns the next page of messages older than the
given row id — clients pass the id of the last message they
already have (or the value of the `X-Next-Cursor` response
header from the previous request). Both params are additive:
omit them and the response is the same first-page array
existing callers expect.

 * @summary List elf messages for the current team
 */
export const getListInboxUrl = (params?: ListInboxParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inbox?${stringifiedParams}`
    : `/api/inbox`;
};

export const listInbox = async (
  params?: ListInboxParams,
  options?: RequestInit,
): Promise<InboxMessage[]> => {
  return customFetch<InboxMessage[]>(getListInboxUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInboxQueryKey = (params?: ListInboxParams) => {
  return [`/api/inbox`, ...(params ? [params] : [])] as const;
};

export const getListInboxQueryOptions = <
  TData = Awaited<ReturnType<typeof listInbox>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  params?: ListInboxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInbox>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInboxQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInbox>>> = ({
    signal,
  }) => listInbox(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInbox>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInboxQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInbox>>
>;
export type ListInboxQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary List elf messages for the current team
 */

export function useListInbox<
  TData = Awaited<ReturnType<typeof listInbox>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  params?: ListInboxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInbox>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInboxQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark a message as read
 */
export const getMarkInboxReadUrl = (id: number) => {
  return `/api/inbox/${id}/read`;
};

export const markInboxRead = async (
  id: number,
  options?: RequestInit,
): Promise<InboxMessage> => {
  return customFetch<InboxMessage>(getMarkInboxReadUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getMarkInboxReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markInboxRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markInboxRead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["markInboxRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markInboxRead>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return markInboxRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkInboxReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markInboxRead>>
>;

export type MarkInboxReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark a message as read
 */
export const useMarkInboxRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markInboxRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markInboxRead>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getMarkInboxReadMutationOptions(options));
};

/**
 * Active mission clues for the current team, ordered by `(day, id)`
ascending. Optional `?limit=` (default 50, max 100) caps the page
size. Optional `?cursor=ID` returns the slice that comes AFTER
the cursor row in `(day, id)` order — clients pass the id of the
last hunt they already have (or the value of the `X-Next-Cursor`
response header from the previous request). The server resolves
the cursor's `day` and applies the compound predicate
`day > cursor.day OR (day = cursor.day AND id > cursor.id)`,
so pagination stays correct even when monotonic id and day
disagree (e.g., admin backfills, mission-generator inserts).
Both params are additive and preserve the legacy array
response shape.

 * @summary Active hunts for the current team
 */
export const getListActiveHuntsUrl = (params?: ListActiveHuntsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/hunts/active?${stringifiedParams}`
    : `/api/hunts/active`;
};

export const listActiveHunts = async (
  params?: ListActiveHuntsParams,
  options?: RequestInit,
): Promise<Hunt[]> => {
  return customFetch<Hunt[]>(getListActiveHuntsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListActiveHuntsQueryKey = (params?: ListActiveHuntsParams) => {
  return [`/api/hunts/active`, ...(params ? [params] : [])] as const;
};

export const getListActiveHuntsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveHunts>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  params?: ListActiveHuntsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listActiveHunts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActiveHuntsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActiveHunts>>> = ({
    signal,
  }) => listActiveHunts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveHunts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveHuntsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveHunts>>
>;
export type ListActiveHuntsQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Active hunts for the current team
 */

export function useListActiveHunts<
  TData = Awaited<ReturnType<typeof listActiveHunts>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  params?: ListActiveHuntsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listActiveHunts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActiveHuntsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Hunt detail (with previous attempts)
 */
export const getGetHuntUrl = (id: number) => {
  return `/api/hunts/${id}`;
};

export const getHunt = async (
  id: number,
  options?: RequestInit,
): Promise<HuntDetail> => {
  return customFetch<HuntDetail>(getGetHuntUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetHuntQueryKey = (id: number) => {
  return [`/api/hunts/${id}`] as const;
};

export const getGetHuntQueryOptions = <
  TData = Awaited<ReturnType<typeof getHunt>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getHunt>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHuntQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHunt>>> = ({
    signal,
  }) => getHunt(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getHunt>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetHuntQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHunt>>
>;
export type GetHuntQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Hunt detail (with previous attempts)
 */

export function useGetHunt<
  TData = Awaited<ReturnType<typeof getHunt>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getHunt>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetHuntQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Submit a photo for a hunt; verifies with Claude Vision
 */
export const getSubmitFindUrl = (id: number) => {
  return `/api/hunts/${id}/finds`;
};

export const submitFind = async (
  id: number,
  submitFindRequest: SubmitFindRequest,
  options?: RequestInit,
): Promise<FindResult> => {
  return customFetch<FindResult>(getSubmitFindUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(submitFindRequest),
  });
};

export const getSubmitFindMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitFind>>,
    TError,
    { id: number; data: BodyType<SubmitFindRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitFind>>,
  TError,
  { id: number; data: BodyType<SubmitFindRequest> },
  TContext
> => {
  const mutationKey = ["submitFind"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitFind>>,
    { id: number; data: BodyType<SubmitFindRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return submitFind(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitFindMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitFind>>
>;
export type SubmitFindMutationBody = BodyType<SubmitFindRequest>;
export type SubmitFindMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Submit a photo for a hunt; verifies with Claude Vision
 */
export const useSubmitFind = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitFind>>,
    TError,
    { id: number; data: BodyType<SubmitFindRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitFind>>,
  TError,
  { id: number; data: BodyType<SubmitFindRequest> },
  TContext
> => {
  return useMutation(getSubmitFindMutationOptions(options));
};

/**
 * Most recent finds for the current team, newest first. Optional
`?limit=` (default 50, max 100). Optional `?cursor=ID` returns
finds older than the given row id, so clients can lazily load
deeper history without a single huge response. Pass the value
of the `X-Next-Cursor` response header from the previous
request to fetch the next page. Both params are additive and
preserve the legacy array response shape.

 * @summary All finds by current team
 */
export const getListMyFindsUrl = (params?: ListMyFindsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/finds?${stringifiedParams}`
    : `/api/finds`;
};

export const listMyFinds = async (
  params?: ListMyFindsParams,
  options?: RequestInit,
): Promise<Find[]> => {
  return customFetch<Find[]>(getListMyFindsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMyFindsQueryKey = (params?: ListMyFindsParams) => {
  return [`/api/finds`, ...(params ? [params] : [])] as const;
};

export const getListMyFindsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyFinds>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMyFindsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMyFinds>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyFindsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyFinds>>> = ({
    signal,
  }) => listMyFinds(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyFinds>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMyFindsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyFinds>>
>;
export type ListMyFindsQueryError = ErrorType<unknown>;

/**
 * @summary All finds by current team
 */

export function useListMyFinds<
  TData = Awaited<ReturnType<typeof listMyFinds>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMyFindsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMyFinds>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMyFindsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * All verified finds across the active mission, newest first.
Optional `?limit=` (default 50, max 100). Optional `?cursor=ID`
returns pins older than the given row id — clients pass the id
of the last pin already on the map (or the value of the
`X-Next-Cursor` response header from the previous request) to
load older ones. Both params are additive and preserve the
legacy array response shape. The aurora heatmap endpoint is
intentionally not cursor-paginated (it returns the full
aggregate snapshot).

 * @summary All finds across all teams (for the living map)
 */
export const getListMapFindsUrl = (params?: ListMapFindsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/map/finds?${stringifiedParams}`
    : `/api/map/finds`;
};

export const listMapFinds = async (
  params?: ListMapFindsParams,
  options?: RequestInit,
): Promise<MapFind[]> => {
  return customFetch<MapFind[]>(getListMapFindsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMapFindsQueryKey = (params?: ListMapFindsParams) => {
  return [`/api/map/finds`, ...(params ? [params] : [])] as const;
};

export const getListMapFindsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMapFinds>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMapFindsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMapFinds>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMapFindsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMapFinds>>> = ({
    signal,
  }) => listMapFinds(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMapFinds>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMapFindsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMapFinds>>
>;
export type ListMapFindsQueryError = ErrorType<unknown>;

/**
 * @summary All finds across all teams (for the living map)
 */

export function useListMapFinds<
  TData = Awaited<ReturnType<typeof listMapFinds>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMapFindsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMapFinds>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMapFindsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Aurora intensity grid (per team color heatmap)
 */
export const getGetAuroraUrl = () => {
  return `/api/map/aurora`;
};

export const getAurora = async (options?: RequestInit): Promise<Aurora> => {
  return customFetch<Aurora>(getGetAuroraUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAuroraQueryKey = () => {
  return [`/api/map/aurora`] as const;
};

export const getGetAuroraQueryOptions = <
  TData = Awaited<ReturnType<typeof getAurora>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAurora>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuroraQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAurora>>> = ({
    signal,
  }) => getAurora({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAurora>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAuroraQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAurora>>
>;
export type GetAuroraQueryError = ErrorType<unknown>;

/**
 * @summary Aurora intensity grid (per team color heatmap)
 */

export function useGetAurora<
  TData = Awaited<ReturnType<typeof getAurora>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAurora>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAuroraQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Daily postcards for the current team, newest first. Optional
`?limit=` (default 50, max 100). Optional `?cursor=ID` returns
postcards older than the given row id so families with months
of past Christmas missions can fetch deeper history on demand.
Pass the value of the `X-Next-Cursor` response header from the
previous request to fetch the next page. Both params are
additive and preserve the legacy array response shape.

 * @summary Daily postcards for current team
 */
export const getListPostcardsUrl = (params?: ListPostcardsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/postcards?${stringifiedParams}`
    : `/api/postcards`;
};

export const listPostcards = async (
  params?: ListPostcardsParams,
  options?: RequestInit,
): Promise<Postcard[]> => {
  return customFetch<Postcard[]>(getListPostcardsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPostcardsQueryKey = (params?: ListPostcardsParams) => {
  return [`/api/postcards`, ...(params ? [params] : [])] as const;
};

export const getListPostcardsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPostcards>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPostcardsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPostcards>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPostcardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPostcards>>> = ({
    signal,
  }) => listPostcards(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPostcards>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPostcardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPostcards>>
>;
export type ListPostcardsQueryError = ErrorType<unknown>;

/**
 * @summary Daily postcards for current team
 */

export function useListPostcards<
  TData = Awaited<ReturnType<typeof listPostcards>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPostcardsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPostcards>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPostcardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Global game state — day, moment status, leaderboard
 */
export const getGetGameStateUrl = () => {
  return `/api/game/state`;
};

export const getGameState = async (
  options?: RequestInit,
): Promise<GameState> => {
  return customFetch<GameState>(getGetGameStateUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGameStateQueryKey = () => {
  return [`/api/game/state`] as const;
};

export const getGetGameStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getGameState>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGameState>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGameStateQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGameState>>> = ({
    signal,
  }) => getGameState({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGameState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGameStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGameState>>
>;
export type GetGameStateQueryError = ErrorType<unknown>;

/**
 * @summary Global game state — day, moment status, leaderboard
 */

export function useGetGameState<
  TData = Awaited<ReturnType<typeof getGameState>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGameState>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGameStateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Active mission's Santa-intro narrative beat (player-facing)
 */
export const getGetMissionNarrativeUrl = () => {
  return `/api/game/narrative`;
};

export const getMissionNarrative = async (
  options?: RequestInit,
): Promise<MissionNarrative> => {
  return customFetch<MissionNarrative>(getGetMissionNarrativeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMissionNarrativeQueryKey = () => {
  return [`/api/game/narrative`] as const;
};

export const getGetMissionNarrativeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMissionNarrative>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMissionNarrative>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMissionNarrativeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMissionNarrative>>
  > = ({ signal }) => getMissionNarrative({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMissionNarrative>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMissionNarrativeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMissionNarrative>>
>;
export type GetMissionNarrativeQueryError = ErrorType<unknown>;

/**
 * @summary Active mission's Santa-intro narrative beat (player-facing)
 */

export function useGetMissionNarrative<
  TData = Awaited<ReturnType<typeof getMissionNarrative>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMissionNarrative>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMissionNarrativeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Admin dashboard state
 */
export const getGetAdminStateUrl = () => {
  return `/api/admin/state`;
};

export const getAdminState = async (
  options?: RequestInit,
): Promise<AdminState> => {
  return customFetch<AdminState>(getGetAdminStateUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminStateQueryKey = () => {
  return [`/api/admin/state`] as const;
};

export const getGetAdminStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminState>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminState>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminStateQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminState>>> = ({
    signal,
  }) => getAdminState({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminState>>
>;
export type GetAdminStateQueryError = ErrorType<unknown>;

/**
 * @summary Admin dashboard state
 */

export function useGetAdminState<
  TData = Awaited<ReturnType<typeof getAdminState>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminState>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminStateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Fire a synchronized moment (e.g. sleigh arrival)
 */
export const getTriggerMomentUrl = () => {
  return `/api/admin/trigger-moment`;
};

export const triggerMoment = async (
  triggerMomentRequest: TriggerMomentRequest,
  options?: RequestInit,
): Promise<Moment> => {
  return customFetch<Moment>(getTriggerMomentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(triggerMomentRequest),
  });
};

export const getTriggerMomentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerMoment>>,
    TError,
    { data: BodyType<TriggerMomentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerMoment>>,
  TError,
  { data: BodyType<TriggerMomentRequest> },
  TContext
> => {
  const mutationKey = ["triggerMoment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerMoment>>,
    { data: BodyType<TriggerMomentRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return triggerMoment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerMomentMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerMoment>>
>;
export type TriggerMomentMutationBody = BodyType<TriggerMomentRequest>;
export type TriggerMomentMutationError = ErrorType<unknown>;

/**
 * @summary Fire a synchronized moment (e.g. sleigh arrival)
 */
export const useTriggerMoment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerMoment>>,
    TError,
    { data: BodyType<TriggerMomentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof triggerMoment>>,
  TError,
  { data: BodyType<TriggerMomentRequest> },
  TContext
> => {
  return useMutation(getTriggerMomentMutationOptions(options));
};

/**
 * @summary Generate and send an elf message to one or all teams
 */
export const getSeedElfMessageUrl = () => {
  return `/api/admin/seed-elf-message`;
};

export const seedElfMessage = async (
  seedElfMessageRequest: SeedElfMessageRequest,
  options?: RequestInit,
): Promise<InboxMessage[]> => {
  return customFetch<InboxMessage[]>(getSeedElfMessageUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(seedElfMessageRequest),
  });
};

export const getSeedElfMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof seedElfMessage>>,
    TError,
    { data: BodyType<SeedElfMessageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof seedElfMessage>>,
  TError,
  { data: BodyType<SeedElfMessageRequest> },
  TContext
> => {
  const mutationKey = ["seedElfMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof seedElfMessage>>,
    { data: BodyType<SeedElfMessageRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return seedElfMessage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SeedElfMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof seedElfMessage>>
>;
export type SeedElfMessageMutationBody = BodyType<SeedElfMessageRequest>;
export type SeedElfMessageMutationError = ErrorType<unknown>;

/**
 * @summary Generate and send an elf message to one or all teams
 */
export const useSeedElfMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof seedElfMessage>>,
    TError,
    { data: BodyType<SeedElfMessageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof seedElfMessage>>,
  TError,
  { data: BodyType<SeedElfMessageRequest> },
  TContext
> => {
  return useMutation(getSeedElfMessageMutationOptions(options));
};

/**
 * @summary Advance the simulated game day
 */
export const getAdvanceDayUrl = () => {
  return `/api/admin/advance-day`;
};

export const advanceDay = async (
  advanceDayRequest: AdvanceDayRequest,
  options?: RequestInit,
): Promise<GameState> => {
  return customFetch<GameState>(getAdvanceDayUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(advanceDayRequest),
  });
};

export const getAdvanceDayMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof advanceDay>>,
    TError,
    { data: BodyType<AdvanceDayRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof advanceDay>>,
  TError,
  { data: BodyType<AdvanceDayRequest> },
  TContext
> => {
  const mutationKey = ["advanceDay"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof advanceDay>>,
    { data: BodyType<AdvanceDayRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return advanceDay(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdvanceDayMutationResult = NonNullable<
  Awaited<ReturnType<typeof advanceDay>>
>;
export type AdvanceDayMutationBody = BodyType<AdvanceDayRequest>;
export type AdvanceDayMutationError = ErrorType<unknown>;

/**
 * @summary Advance the simulated game day
 */
export const useAdvanceDay = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof advanceDay>>,
    TError,
    { data: BodyType<AdvanceDayRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof advanceDay>>,
  TError,
  { data: BodyType<AdvanceDayRequest> },
  TContext
> => {
  return useMutation(getAdvanceDayMutationOptions(options));
};

/**
 * @summary Read-only family setup card for the host
 */
export const getGetAdminFamilyUrl = () => {
  return `/api/admin/family`;
};

export const getAdminFamily = async (
  options?: RequestInit,
): Promise<AdminFamily> => {
  return customFetch<AdminFamily>(getGetAdminFamilyUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminFamilyQueryKey = () => {
  return [`/api/admin/family`] as const;
};

export const getGetAdminFamilyQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminFamily>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminFamily>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminFamilyQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFamily>>> = ({
    signal,
  }) => getAdminFamily({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminFamily>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminFamilyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminFamily>>
>;
export type GetAdminFamilyQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Read-only family setup card for the host
 */

export function useGetAdminFamily<
  TData = Awaited<ReturnType<typeof getAdminFamily>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminFamily>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminFamilyQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List active memberships in the current family
 */
export const getListAdminMembersUrl = () => {
  return `/api/admin/members`;
};

export const listAdminMembers = async (
  options?: RequestInit,
): Promise<AdminMember[]> => {
  return customFetch<AdminMember[]>(getListAdminMembersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAdminMembersQueryKey = () => {
  return [`/api/admin/members`] as const;
};

export const getListAdminMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminMembers>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminMembers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminMembersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminMembers>>
  > = ({ signal }) => listAdminMembers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminMembers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminMembers>>
>;
export type ListAdminMembersQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary List active memberships in the current family
 */

export function useListAdminMembers<
  TData = Awaited<ReturnType<typeof listAdminMembers>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminMembers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminMembersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Revoke a member from the current family
 */
export const getRemoveAdminMemberUrl = (membershipId: number) => {
  return `/api/admin/members/${membershipId}/remove`;
};

export const removeAdminMember = async (
  membershipId: number,
  removeAdminMemberRequest: RemoveAdminMemberRequest,
  options?: RequestInit,
): Promise<AdminMembershipOk> => {
  return customFetch<AdminMembershipOk>(getRemoveAdminMemberUrl(membershipId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(removeAdminMemberRequest),
  });
};

export const getRemoveAdminMemberMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeAdminMember>>,
    TError,
    { membershipId: number; data: BodyType<RemoveAdminMemberRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeAdminMember>>,
  TError,
  { membershipId: number; data: BodyType<RemoveAdminMemberRequest> },
  TContext
> => {
  const mutationKey = ["removeAdminMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeAdminMember>>,
    { membershipId: number; data: BodyType<RemoveAdminMemberRequest> }
  > = (props) => {
    const { membershipId, data } = props ?? {};

    return removeAdminMember(membershipId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveAdminMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeAdminMember>>
>;
export type RemoveAdminMemberMutationBody = BodyType<RemoveAdminMemberRequest>;
export type RemoveAdminMemberMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Revoke a member from the current family
 */
export const useRemoveAdminMember = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeAdminMember>>,
    TError,
    { membershipId: number; data: BodyType<RemoveAdminMemberRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeAdminMember>>,
  TError,
  { membershipId: number; data: BodyType<RemoveAdminMemberRequest> },
  TContext
> => {
  return useMutation(getRemoveAdminMemberMutationOptions(options));
};

/**
 * Family Safety + Kid Mode v1, plus co-host promote (Task #322). The host can flip a member between `child` and `player`, and the family owner can promote a `player` to `admin` (co-host) or demote an `admin` back to `player`. The family `owner` role can never be changed through this endpoint. A `child` profile cannot be jumped directly to `admin`: the host must mark them as `player` first.

 * @summary Change a member's role between child, player, and admin (co-host)
 */
export const getSetAdminMemberRoleUrl = (membershipId: number) => {
  return `/api/admin/members/${membershipId}/role`;
};

export const setAdminMemberRole = async (
  membershipId: number,
  setAdminMemberRoleRequest: SetAdminMemberRoleRequest,
  options?: RequestInit,
): Promise<AdminMembershipOk> => {
  return customFetch<AdminMembershipOk>(
    getSetAdminMemberRoleUrl(membershipId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setAdminMemberRoleRequest),
    },
  );
};

export const getSetAdminMemberRoleMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAdminMemberRole>>,
    TError,
    { membershipId: number; data: BodyType<SetAdminMemberRoleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAdminMemberRole>>,
  TError,
  { membershipId: number; data: BodyType<SetAdminMemberRoleRequest> },
  TContext
> => {
  const mutationKey = ["setAdminMemberRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAdminMemberRole>>,
    { membershipId: number; data: BodyType<SetAdminMemberRoleRequest> }
  > = (props) => {
    const { membershipId, data } = props ?? {};

    return setAdminMemberRole(membershipId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAdminMemberRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAdminMemberRole>>
>;
export type SetAdminMemberRoleMutationBody =
  BodyType<SetAdminMemberRoleRequest>;
export type SetAdminMemberRoleMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Change a member's role between child, player, and admin (co-host)
 */
export const useSetAdminMemberRole = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAdminMemberRole>>,
    TError,
    { membershipId: number; data: BodyType<SetAdminMemberRoleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setAdminMemberRole>>,
  TError,
  { membershipId: number; data: BodyType<SetAdminMemberRoleRequest> },
  TContext
> => {
  return useMutation(getSetAdminMemberRoleMutationOptions(options));
};

/**
 * @summary Issue a one-time temporary password and force change on next login
 */
export const getResetAdminMemberPasswordUrl = (membershipId: number) => {
  return `/api/admin/members/${membershipId}/reset-password`;
};

export const resetAdminMemberPassword = async (
  membershipId: number,
  options?: RequestInit,
): Promise<AdminResetPasswordResponse> => {
  return customFetch<AdminResetPasswordResponse>(
    getResetAdminMemberPasswordUrl(membershipId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getResetAdminMemberPasswordMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetAdminMemberPassword>>,
    TError,
    { membershipId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetAdminMemberPassword>>,
  TError,
  { membershipId: number },
  TContext
> => {
  const mutationKey = ["resetAdminMemberPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetAdminMemberPassword>>,
    { membershipId: number }
  > = (props) => {
    const { membershipId } = props ?? {};

    return resetAdminMemberPassword(membershipId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetAdminMemberPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetAdminMemberPassword>>
>;

export type ResetAdminMemberPasswordMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Issue a one-time temporary password and force change on next login
 */
export const useResetAdminMemberPassword = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetAdminMemberPassword>>,
    TError,
    { membershipId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetAdminMemberPassword>>,
  TError,
  { membershipId: number },
  TContext
> => {
  return useMutation(getResetAdminMemberPasswordMutationOptions(options));
};

/**
 * @summary List every invitation for the current family
 */
export const getListAdminInvitationsUrl = () => {
  return `/api/admin/invitations`;
};

export const listAdminInvitations = async (
  options?: RequestInit,
): Promise<AdminInvite[]> => {
  return customFetch<AdminInvite[]>(getListAdminInvitationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAdminInvitationsQueryKey = () => {
  return [`/api/admin/invitations`] as const;
};

export const getListAdminInvitationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminInvitations>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminInvitations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminInvitationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminInvitations>>
  > = ({ signal }) => listAdminInvitations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminInvitations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminInvitationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminInvitations>>
>;
export type ListAdminInvitationsQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary List every invitation for the current family
 */

export function useListAdminInvitations<
  TData = Awaited<ReturnType<typeof listAdminInvitations>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminInvitations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminInvitationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mint a fresh invitation code
 */
export const getMintAdminInvitationUrl = () => {
  return `/api/admin/invitations`;
};

export const mintAdminInvitation = async (
  mintAdminInvitationRequest: MintAdminInvitationRequest,
  options?: RequestInit,
): Promise<MintedAdminInvitation> => {
  return customFetch<MintedAdminInvitation>(getMintAdminInvitationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mintAdminInvitationRequest),
  });
};

export const getMintAdminInvitationMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mintAdminInvitation>>,
    TError,
    { data: BodyType<MintAdminInvitationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mintAdminInvitation>>,
  TError,
  { data: BodyType<MintAdminInvitationRequest> },
  TContext
> => {
  const mutationKey = ["mintAdminInvitation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mintAdminInvitation>>,
    { data: BodyType<MintAdminInvitationRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return mintAdminInvitation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MintAdminInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof mintAdminInvitation>>
>;
export type MintAdminInvitationMutationBody =
  BodyType<MintAdminInvitationRequest>;
export type MintAdminInvitationMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Mint a fresh invitation code
 */
export const useMintAdminInvitation = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mintAdminInvitation>>,
    TError,
    { data: BodyType<MintAdminInvitationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof mintAdminInvitation>>,
  TError,
  { data: BodyType<MintAdminInvitationRequest> },
  TContext
> => {
  return useMutation(getMintAdminInvitationMutationOptions(options));
};

/**
 * @summary Revoke an invitation
 */
export const getRevokeAdminInvitationUrl = (id: number) => {
  return `/api/admin/invitations/${id}/revoke`;
};

export const revokeAdminInvitation = async (
  id: number,
  options?: RequestInit,
): Promise<AdminInvitationOk> => {
  return customFetch<AdminInvitationOk>(getRevokeAdminInvitationUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRevokeAdminInvitationMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeAdminInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeAdminInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["revokeAdminInvitation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeAdminInvitation>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return revokeAdminInvitation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeAdminInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeAdminInvitation>>
>;

export type RevokeAdminInvitationMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Revoke an invitation
 */
export const useRevokeAdminInvitation = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeAdminInvitation>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeAdminInvitation>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRevokeAdminInvitationMutationOptions(options));
};

/**
 * @summary Derived "First Mission Launchpad" readiness for the host's active mission
 */
export const getGetAdminLaunchpadUrl = () => {
  return `/api/admin/launchpad`;
};

export const getAdminLaunchpad = async (
  options?: RequestInit,
): Promise<AdminLaunchpad> => {
  return customFetch<AdminLaunchpad>(getGetAdminLaunchpadUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminLaunchpadQueryKey = () => {
  return [`/api/admin/launchpad`] as const;
};

export const getGetAdminLaunchpadQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminLaunchpad>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminLaunchpad>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminLaunchpadQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminLaunchpad>>
  > = ({ signal }) => getAdminLaunchpad({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminLaunchpad>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminLaunchpadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminLaunchpad>>
>;
export type GetAdminLaunchpadQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Derived "First Mission Launchpad" readiness for the host's active mission
 */

export function useGetAdminLaunchpad<
  TData = Awaited<ReturnType<typeof getAdminLaunchpad>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminLaunchpad>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminLaunchpadQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Self-serve "Download my family's data" export. Returns a
`application/zip` attachment containing JSON projections of every
tenant-scoped table (family, members, teams, missions, mission
state, hunts, finds, postcards, inbox, voice asset manifest,
invitations, audit events, billing summary) plus the original
find/postcard photo bytes. Records a `family_data_exported`
admin audit event after a successful build.

 * @summary Stream a ZIP archive of the caller's tenant data
 */
export const getExportAdminFamilyUrl = () => {
  return `/api/admin/family/export`;
};

export const exportAdminFamily = async (
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getExportAdminFamilyUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportAdminFamilyQueryKey = () => {
  return [`/api/admin/family/export`] as const;
};

export const getExportAdminFamilyQueryOptions = <
  TData = Awaited<ReturnType<typeof exportAdminFamily>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportAdminFamily>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportAdminFamilyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportAdminFamily>>
  > = ({ signal }) => exportAdminFamily({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportAdminFamily>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportAdminFamilyQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportAdminFamily>>
>;
export type ExportAdminFamilyQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Stream a ZIP archive of the caller's tenant data
 */

export function useExportAdminFamily<
  TData = Awaited<ReturnType<typeof exportAdminFamily>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportAdminFamily>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportAdminFamilyQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Soft-delete a find photo (and undo its score, if any)
 */
export const getDeleteAdminFindUrl = (id: number) => {
  return `/api/admin/finds/${id}/delete`;
};

export const deleteAdminFind = async (
  id: number,
  deleteAdminFindRequest: DeleteAdminFindRequest,
  options?: RequestInit,
): Promise<AdminFindOk> => {
  return customFetch<AdminFindOk>(getDeleteAdminFindUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(deleteAdminFindRequest),
  });
};

export const getDeleteAdminFindMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminFind>>,
    TError,
    { id: number; data: BodyType<DeleteAdminFindRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminFind>>,
  TError,
  { id: number; data: BodyType<DeleteAdminFindRequest> },
  TContext
> => {
  const mutationKey = ["deleteAdminFind"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminFind>>,
    { id: number; data: BodyType<DeleteAdminFindRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return deleteAdminFind(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminFindMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminFind>>
>;
export type DeleteAdminFindMutationBody = BodyType<DeleteAdminFindRequest>;
export type DeleteAdminFindMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Soft-delete a find photo (and undo its score, if any)
 */
export const useDeleteAdminFind = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminFind>>,
    TError,
    { id: number; data: BodyType<DeleteAdminFindRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminFind>>,
  TError,
  { id: number; data: BodyType<DeleteAdminFindRequest> },
  TContext
> => {
  return useMutation(getDeleteAdminFindMutationOptions(options));
};

/**
 * Lightweight, public, rate-limited probe used by the host-setup step of
the /create wizard so the user is told *at form-step time* that an
email is already taken instead of after the final submit. Returns
`{ taken: true }` only if a user already exists with that email
(case-insensitive). Empty / malformed emails return `{ taken: false }`
— the final create-beta submit is still the source of truth for
format and uniqueness.

 * @summary Pre-flight check whether a host email address is already in use
 */
export const getCheckHostEmailAvailabilityUrl = () => {
  return `/api/families/check-email`;
};

export const checkHostEmailAvailability = async (
  checkHostEmailRequest: CheckHostEmailRequest,
  options?: RequestInit,
): Promise<CheckHostEmailResponse> => {
  return customFetch<CheckHostEmailResponse>(
    getCheckHostEmailAvailabilityUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(checkHostEmailRequest),
    },
  );
};

export const getCheckHostEmailAvailabilityMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkHostEmailAvailability>>,
    TError,
    { data: BodyType<CheckHostEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkHostEmailAvailability>>,
  TError,
  { data: BodyType<CheckHostEmailRequest> },
  TContext
> => {
  const mutationKey = ["checkHostEmailAvailability"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkHostEmailAvailability>>,
    { data: BodyType<CheckHostEmailRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return checkHostEmailAvailability(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckHostEmailAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkHostEmailAvailability>>
>;
export type CheckHostEmailAvailabilityMutationBody =
  BodyType<CheckHostEmailRequest>;
export type CheckHostEmailAvailabilityMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Pre-flight check whether a host email address is already in use
 */
export const useCheckHostEmailAvailability = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkHostEmailAvailability>>,
    TError,
    { data: BodyType<CheckHostEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof checkHostEmailAvailability>>,
  TError,
  { data: BodyType<CheckHostEmailRequest> },
  TContext
> => {
  return useMutation(getCheckHostEmailAvailabilityMutationOptions(options));
};

/**
 * @summary Create a beta family with a host user, starter mission, and starter teams
 */
export const getCreateBetaUrl = () => {
  return `/api/families/create-beta`;
};

export const createBeta = async (
  createBetaRequest: CreateBetaRequest,
  options?: RequestInit,
): Promise<CreatedBetaFamily> => {
  return customFetch<CreatedBetaFamily>(getCreateBetaUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBetaRequest),
  });
};

export const getCreateBetaMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBeta>>,
    TError,
    { data: BodyType<CreateBetaRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBeta>>,
  TError,
  { data: BodyType<CreateBetaRequest> },
  TContext
> => {
  const mutationKey = ["createBeta"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBeta>>,
    { data: BodyType<CreateBetaRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createBeta(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBetaMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBeta>>
>;
export type CreateBetaMutationBody = BodyType<CreateBetaRequest>;
export type CreateBetaMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Create a beta family with a host user, starter mission, and starter teams
 */
export const useCreateBeta = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBeta>>,
    TError,
    { data: BodyType<CreateBetaRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBeta>>,
  TError,
  { data: BodyType<CreateBetaRequest> },
  TContext
> => {
  return useMutation(getCreateBetaMutationOptions(options));
};

/**
 * Returns the small preview shown to a joiner before they accept the
invite, so the join wizard can confirm "yes, this is the right
family/mission, hosted by the right person." Does NOT reveal team
rosters, member counts, or anything else beyond what's needed to
confirm the invite. Public — no session required. Rate-limited.

 * @summary Public preview of an invite (family, mission, teams, role)
 */
export const getGetInvitePreviewUrl = (code: string) => {
  return `/api/invitations/${code}`;
};

export const getInvitePreview = async (
  code: string,
  options?: RequestInit,
): Promise<InvitePreview> => {
  return customFetch<InvitePreview>(getGetInvitePreviewUrl(code), {
    ...options,
    method: "GET",
  });
};

export const getGetInvitePreviewQueryKey = (code: string) => {
  return [`/api/invitations/${code}`] as const;
};

export const getGetInvitePreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvitePreview>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  code: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvitePreview>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInvitePreviewQueryKey(code);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInvitePreview>>
  > = ({ signal }) => getInvitePreview(code, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!code,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvitePreview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInvitePreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvitePreview>>
>;
export type GetInvitePreviewQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Public preview of an invite (family, mission, teams, role)
 */

export function useGetInvitePreview<
  TData = Awaited<ReturnType<typeof getInvitePreview>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  code: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvitePreview>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInvitePreviewQueryOptions(code, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Redeem an invite code, create a player user, and start a session
 */
export const getAcceptInviteUrl = (code: string) => {
  return `/api/invitations/${code}/accept`;
};

export const acceptInvite = async (
  code: string,
  acceptInviteRequest: AcceptInviteRequest,
  options?: RequestInit,
): Promise<AcceptedInvite> => {
  return customFetch<AcceptedInvite>(getAcceptInviteUrl(code), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(acceptInviteRequest),
  });
};

export const getAcceptInviteMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvite>>,
    TError,
    { code: string; data: BodyType<AcceptInviteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptInvite>>,
  TError,
  { code: string; data: BodyType<AcceptInviteRequest> },
  TContext
> => {
  const mutationKey = ["acceptInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptInvite>>,
    { code: string; data: BodyType<AcceptInviteRequest> }
  > = (props) => {
    const { code, data } = props ?? {};

    return acceptInvite(code, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptInvite>>
>;
export type AcceptInviteMutationBody = BodyType<AcceptInviteRequest>;
export type AcceptInviteMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Redeem an invite code, create a player user, and start a session
 */
export const useAcceptInvite = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvite>>,
    TError,
    { code: string; data: BodyType<AcceptInviteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptInvite>>,
  TError,
  { code: string; data: BodyType<AcceptInviteRequest> },
  TContext
> => {
  return useMutation(getAcceptInviteMutationOptions(options));
};

/**
 * Public. Returns the registry entries required for a given acceptance
context so the frontend can render the correct checkboxes. Pass
`context=signup|join_family|create_family|host_kids_playing|purchase|policy_update`
to get context-filtered policies. Omit to get all registry policies.

 * @summary Returns policy registry entries required for a given context
 */
export const getGetLegalRequiredPoliciesUrl = (
  params?: GetLegalRequiredPoliciesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/legal/required-policies?${stringifiedParams}`
    : `/api/legal/required-policies`;
};

export const getLegalRequiredPolicies = async (
  params?: GetLegalRequiredPoliciesParams,
  options?: RequestInit,
): Promise<LegalRequiredPoliciesResponse> => {
  return customFetch<LegalRequiredPoliciesResponse>(
    getGetLegalRequiredPoliciesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetLegalRequiredPoliciesQueryKey = (
  params?: GetLegalRequiredPoliciesParams,
) => {
  return [`/api/legal/required-policies`, ...(params ? [params] : [])] as const;
};

export const getGetLegalRequiredPoliciesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLegalRequiredPolicies>>,
  TError = ErrorType<unknown>,
>(
  params?: GetLegalRequiredPoliciesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLegalRequiredPolicies>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLegalRequiredPoliciesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLegalRequiredPolicies>>
  > = ({ signal }) =>
    getLegalRequiredPolicies(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLegalRequiredPolicies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLegalRequiredPoliciesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLegalRequiredPolicies>>
>;
export type GetLegalRequiredPoliciesQueryError = ErrorType<unknown>;

/**
 * @summary Returns policy registry entries required for a given context
 */

export function useGetLegalRequiredPolicies<
  TData = Awaited<ReturnType<typeof getLegalRequiredPolicies>>,
  TError = ErrorType<unknown>,
>(
  params?: GetLegalRequiredPoliciesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLegalRequiredPolicies>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLegalRequiredPoliciesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Auth-required. Returns which required policies (signup context) the
session user has not yet accepted at the current registry version.
Use on app boot to detect whether the policy-update gate is needed.

 * @summary Returns missing required policies for the authenticated user
 */
export const getGetLegalStatusUrl = () => {
  return `/api/legal/status`;
};

export const getLegalStatus = async (
  options?: RequestInit,
): Promise<LegalStatusResponse> => {
  return customFetch<LegalStatusResponse>(getGetLegalStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetLegalStatusQueryKey = () => {
  return [`/api/legal/status`] as const;
};

export const getGetLegalStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getLegalStatus>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLegalStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLegalStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLegalStatus>>> = ({
    signal,
  }) => getLegalStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLegalStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLegalStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLegalStatus>>
>;
export type GetLegalStatusQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Returns missing required policies for the authenticated user
 */

export function useGetLegalStatus<
  TData = Awaited<ReturnType<typeof getLegalStatus>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLegalStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLegalStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Auth-required. Records policy acceptances for the policy-update context
(existing user re-accepting after a policy version bump). Returns 422
if any slug is unknown or any version is stale.

 * @summary Record policy acceptances for an existing authenticated user
 */
export const getRecordLegalAcceptancesUrl = () => {
  return `/api/legal/acceptances`;
};

export const recordLegalAcceptances = async (
  legalAcceptancesRequest: LegalAcceptancesRequest,
  options?: RequestInit,
): Promise<RecordLegalAcceptances200> => {
  return customFetch<RecordLegalAcceptances200>(
    getRecordLegalAcceptancesUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(legalAcceptancesRequest),
    },
  );
};

export const getRecordLegalAcceptancesMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordLegalAcceptances>>,
    TError,
    { data: BodyType<LegalAcceptancesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordLegalAcceptances>>,
  TError,
  { data: BodyType<LegalAcceptancesRequest> },
  TContext
> => {
  const mutationKey = ["recordLegalAcceptances"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordLegalAcceptances>>,
    { data: BodyType<LegalAcceptancesRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return recordLegalAcceptances(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordLegalAcceptancesMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordLegalAcceptances>>
>;
export type RecordLegalAcceptancesMutationBody =
  BodyType<LegalAcceptancesRequest>;
export type RecordLegalAcceptancesMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Record policy acceptances for an existing authenticated user
 */
export const useRecordLegalAcceptances = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordLegalAcceptances>>,
    TError,
    { data: BodyType<LegalAcceptancesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordLegalAcceptances>>,
  TError,
  { data: BodyType<LegalAcceptancesRequest> },
  TContext
> => {
  return useMutation(getRecordLegalAcceptancesMutationOptions(options));
};

/**
 * Host-only. Returns the most-recent generation run, the current
narrative bundle (or null if none), the AI draft / approved clues
for the active mission, and the per-tenant daily generation
budget. The query key emitted by the generated client
(`['/api/mission-control/draft']`) is the canonical cache key
for every Mission Builder mutation to invalidate after edits,
approvals, revisions, narrative saves, and starter restores.

 * @summary Active mission's draft narrative + clues for Mission Control
 */
export const getGetMissionControlDraftUrl = () => {
  return `/api/mission-control/draft`;
};

export const getMissionControlDraft = async (
  options?: RequestInit,
): Promise<MissionControlDraft> => {
  return customFetch<MissionControlDraft>(getGetMissionControlDraftUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMissionControlDraftQueryKey = () => {
  return [`/api/mission-control/draft`] as const;
};

export const getGetMissionControlDraftQueryOptions = <
  TData = Awaited<ReturnType<typeof getMissionControlDraft>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMissionControlDraft>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMissionControlDraftQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMissionControlDraft>>
  > = ({ signal }) => getMissionControlDraft({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMissionControlDraft>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMissionControlDraftQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMissionControlDraft>>
>;
export type GetMissionControlDraftQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Active mission's draft narrative + clues for Mission Control
 */

export function useGetMissionControlDraft<
  TData = Awaited<ReturnType<typeof getMissionControlDraft>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMissionControlDraft>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMissionControlDraftQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Edit the latest draft recap
 */
export const getEditMissionControlRecapUrl = () => {
  return `/api/mission-control/recap`;
};

export const editMissionControlRecap = async (
  recapPatchBody: RecapPatchBody,
  options?: RequestInit,
): Promise<EditMissionControlRecap200> => {
  return customFetch<EditMissionControlRecap200>(
    getEditMissionControlRecapUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(recapPatchBody),
    },
  );
};

export const getEditMissionControlRecapMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editMissionControlRecap>>,
    TError,
    { data: BodyType<RecapPatchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editMissionControlRecap>>,
  TError,
  { data: BodyType<RecapPatchBody> },
  TContext
> => {
  const mutationKey = ["editMissionControlRecap"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editMissionControlRecap>>,
    { data: BodyType<RecapPatchBody> }
  > = (props) => {
    const { data } = props ?? {};

    return editMissionControlRecap(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditMissionControlRecapMutationResult = NonNullable<
  Awaited<ReturnType<typeof editMissionControlRecap>>
>;
export type EditMissionControlRecapMutationBody = BodyType<RecapPatchBody>;
export type EditMissionControlRecapMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Edit the latest draft recap
 */
export const useEditMissionControlRecap = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editMissionControlRecap>>,
    TError,
    { data: BodyType<RecapPatchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof editMissionControlRecap>>,
  TError,
  { data: BodyType<RecapPatchBody> },
  TContext
> => {
  return useMutation(getEditMissionControlRecapMutationOptions(options));
};

/**
 * Host-only. Returns the latest draft recap (if any), the currently-
published recap (if any), hydrated photo cards for both, and the
eligible-finds pool used by the host's photo picker. The query key
emitted by the generated client (`['/api/mission-control/recap']`)
is the canonical cache key for every Mission Control mutation that
affects recap inputs (clues, narrative, finds, members, day index)
to invalidate after edits — the recap surface reads from those, so
any of them changing should refresh the recap card.

 * @summary Active mission's recap state for the host
 */
export const getGetMissionControlRecapUrl = () => {
  return `/api/mission-control/recap`;
};

export const getMissionControlRecap = async (
  options?: RequestInit,
): Promise<HostRecapResponse> => {
  return customFetch<HostRecapResponse>(getGetMissionControlRecapUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMissionControlRecapQueryKey = () => {
  return [`/api/mission-control/recap`] as const;
};

export const getGetMissionControlRecapQueryOptions = <
  TData = Awaited<ReturnType<typeof getMissionControlRecap>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMissionControlRecap>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMissionControlRecapQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMissionControlRecap>>
  > = ({ signal }) => getMissionControlRecap({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMissionControlRecap>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMissionControlRecapQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMissionControlRecap>>
>;
export type GetMissionControlRecapQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Active mission's recap state for the host
 */

export function useGetMissionControlRecap<
  TData = Awaited<ReturnType<typeof getMissionControlRecap>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMissionControlRecap>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMissionControlRecapQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Trigger a new AI mission generation run for the active mission
 */
export const getGenerateMissionControlDraftUrl = () => {
  return `/api/mission-control/generate`;
};

export const generateMissionControlDraft = async (
  missionBuilderInputs: MissionBuilderInputs,
  options?: RequestInit,
): Promise<MissionGenerateResponse> => {
  return customFetch<MissionGenerateResponse>(
    getGenerateMissionControlDraftUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(missionBuilderInputs),
    },
  );
};

export const getGenerateMissionControlDraftMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMissionControlDraft>>,
    TError,
    { data: BodyType<MissionBuilderInputs> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateMissionControlDraft>>,
  TError,
  { data: BodyType<MissionBuilderInputs> },
  TContext
> => {
  const mutationKey = ["generateMissionControlDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateMissionControlDraft>>,
    { data: BodyType<MissionBuilderInputs> }
  > = (props) => {
    const { data } = props ?? {};

    return generateMissionControlDraft(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateMissionControlDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateMissionControlDraft>>
>;
export type GenerateMissionControlDraftMutationBody =
  BodyType<MissionBuilderInputs>;
export type GenerateMissionControlDraftMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Trigger a new AI mission generation run for the active mission
 */
export const useGenerateMissionControlDraft = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMissionControlDraft>>,
    TError,
    { data: BodyType<MissionBuilderInputs> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateMissionControlDraft>>,
  TError,
  { data: BodyType<MissionBuilderInputs> },
  TContext
> => {
  return useMutation(getGenerateMissionControlDraftMutationOptions(options));
};

/**
 * @summary Status of a single generation run (for polling)
 */
export const getGetMissionControlRunUrl = (id: number) => {
  return `/api/mission-control/runs/${id}`;
};

export const getMissionControlRun = async (
  id: number,
  options?: RequestInit,
): Promise<MissionGenerationRun> => {
  return customFetch<MissionGenerationRun>(getGetMissionControlRunUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetMissionControlRunQueryKey = (id: number) => {
  return [`/api/mission-control/runs/${id}`] as const;
};

export const getGetMissionControlRunQueryOptions = <
  TData = Awaited<ReturnType<typeof getMissionControlRun>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMissionControlRun>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMissionControlRunQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMissionControlRun>>
  > = ({ signal }) => getMissionControlRun(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMissionControlRun>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMissionControlRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMissionControlRun>>
>;
export type GetMissionControlRunQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Status of a single generation run (for polling)
 */

export function useGetMissionControlRun<
  TData = Awaited<ReturnType<typeof getMissionControlRun>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMissionControlRun>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMissionControlRunQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Host edit of a single AI draft clue
 */
export const getEditMissionControlClueUrl = (id: number) => {
  return `/api/mission-control/clues/${id}`;
};

export const editMissionControlClue = async (
  id: number,
  editClueBody: EditClueBody,
  options?: RequestInit,
): Promise<AdminClueRow> => {
  return customFetch<AdminClueRow>(getEditMissionControlClueUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(editClueBody),
  });
};

export const getEditMissionControlClueMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editMissionControlClue>>,
    TError,
    { id: number; data: BodyType<EditClueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editMissionControlClue>>,
  TError,
  { id: number; data: BodyType<EditClueBody> },
  TContext
> => {
  const mutationKey = ["editMissionControlClue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editMissionControlClue>>,
    { id: number; data: BodyType<EditClueBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return editMissionControlClue(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditMissionControlClueMutationResult = NonNullable<
  Awaited<ReturnType<typeof editMissionControlClue>>
>;
export type EditMissionControlClueMutationBody = BodyType<EditClueBody>;
export type EditMissionControlClueMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Host edit of a single AI draft clue
 */
export const useEditMissionControlClue = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editMissionControlClue>>,
    TError,
    { id: number; data: BodyType<EditClueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof editMissionControlClue>>,
  TError,
  { id: number; data: BodyType<EditClueBody> },
  TContext
> => {
  return useMutation(getEditMissionControlClueMutationOptions(options));
};

/**
 * @summary Approve a single draft AI clue
 */
export const getApproveMissionControlClueUrl = (id: number) => {
  return `/api/mission-control/clues/${id}/approve`;
};

export const approveMissionControlClue = async (
  id: number,
  options?: RequestInit,
): Promise<AdminClueRow> => {
  return customFetch<AdminClueRow>(getApproveMissionControlClueUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getApproveMissionControlClueMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveMissionControlClue>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveMissionControlClue>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["approveMissionControlClue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveMissionControlClue>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return approveMissionControlClue(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveMissionControlClueMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveMissionControlClue>>
>;

export type ApproveMissionControlClueMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Approve a single draft AI clue
 */
export const useApproveMissionControlClue = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveMissionControlClue>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveMissionControlClue>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getApproveMissionControlClueMutationOptions(options));
};

/**
 * @summary Reject a single draft AI clue
 */
export const getRejectMissionControlClueUrl = (id: number) => {
  return `/api/mission-control/clues/${id}/reject`;
};

export const rejectMissionControlClue = async (
  id: number,
  options?: RequestInit,
): Promise<AdminClueRow> => {
  return customFetch<AdminClueRow>(getRejectMissionControlClueUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRejectMissionControlClueMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectMissionControlClue>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectMissionControlClue>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["rejectMissionControlClue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectMissionControlClue>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return rejectMissionControlClue(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectMissionControlClueMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectMissionControlClue>>
>;

export type RejectMissionControlClueMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Reject a single draft AI clue
 */
export const useRejectMissionControlClue = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectMissionControlClue>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectMissionControlClue>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRejectMissionControlClueMutationOptions(options));
};

/**
 * @summary Ask the AI to rewrite a single clue
 */
export const getReviseMissionControlClueUrl = (id: number) => {
  return `/api/mission-control/clues/${id}/revise`;
};

export const reviseMissionControlClue = async (
  id: number,
  reviseClueBody: ReviseClueBody,
  options?: RequestInit,
): Promise<ReviseClueResponse> => {
  return customFetch<ReviseClueResponse>(getReviseMissionControlClueUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reviseClueBody),
  });
};

export const getReviseMissionControlClueMutationOptions = <
  TError = ErrorType<ErrorEnvelope | ReviseRateLimitedError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviseMissionControlClue>>,
    TError,
    { id: number; data: BodyType<ReviseClueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reviseMissionControlClue>>,
  TError,
  { id: number; data: BodyType<ReviseClueBody> },
  TContext
> => {
  const mutationKey = ["reviseMissionControlClue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reviseMissionControlClue>>,
    { id: number; data: BodyType<ReviseClueBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reviseMissionControlClue(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReviseMissionControlClueMutationResult = NonNullable<
  Awaited<ReturnType<typeof reviseMissionControlClue>>
>;
export type ReviseMissionControlClueMutationBody = BodyType<ReviseClueBody>;
export type ReviseMissionControlClueMutationError = ErrorType<
  ErrorEnvelope | ReviseRateLimitedError
>;

/**
 * @summary Ask the AI to rewrite a single clue
 */
export const useReviseMissionControlClue = <
  TError = ErrorType<ErrorEnvelope | ReviseRateLimitedError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviseMissionControlClue>>,
    TError,
    { id: number; data: BodyType<ReviseClueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reviseMissionControlClue>>,
  TError,
  { id: number; data: BodyType<ReviseClueBody> },
  TContext
> => {
  return useMutation(getReviseMissionControlClueMutationOptions(options));
};

/**
 * @summary Revision history for a single clue
 */
export const getListMissionControlClueRevisionsUrl = (id: number) => {
  return `/api/mission-control/clues/${id}/revisions`;
};

export const listMissionControlClueRevisions = async (
  id: number,
  options?: RequestInit,
): Promise<ListMissionControlClueRevisions200> => {
  return customFetch<ListMissionControlClueRevisions200>(
    getListMissionControlClueRevisionsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListMissionControlClueRevisionsQueryKey = (id: number) => {
  return [`/api/mission-control/clues/${id}/revisions`] as const;
};

export const getListMissionControlClueRevisionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMissionControlClueRevisions>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMissionControlClueRevisions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMissionControlClueRevisionsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMissionControlClueRevisions>>
  > = ({ signal }) =>
    listMissionControlClueRevisions(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMissionControlClueRevisions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMissionControlClueRevisionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMissionControlClueRevisions>>
>;
export type ListMissionControlClueRevisionsQueryError =
  ErrorType<ErrorEnvelope>;

/**
 * @summary Revision history for a single clue
 */

export function useListMissionControlClueRevisions<
  TData = Awaited<ReturnType<typeof listMissionControlClueRevisions>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMissionControlClueRevisions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMissionControlClueRevisionsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete all revision history rows for a clue
 */
export const getClearMissionControlClueRevisionsUrl = (id: number) => {
  return `/api/mission-control/clues/${id}/revisions`;
};

export const clearMissionControlClueRevisions = async (
  id: number,
  options?: RequestInit,
): Promise<ClearMissionControlClueRevisions200> => {
  return customFetch<ClearMissionControlClueRevisions200>(
    getClearMissionControlClueRevisionsUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getClearMissionControlClueRevisionsMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearMissionControlClueRevisions>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearMissionControlClueRevisions>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["clearMissionControlClueRevisions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearMissionControlClueRevisions>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return clearMissionControlClueRevisions(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearMissionControlClueRevisionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearMissionControlClueRevisions>>
>;

export type ClearMissionControlClueRevisionsMutationError =
  ErrorType<ErrorEnvelope>;

/**
 * @summary Delete all revision history rows for a clue
 */
export const useClearMissionControlClueRevisions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearMissionControlClueRevisions>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof clearMissionControlClueRevisions>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(
    getClearMissionControlClueRevisionsMutationOptions(options),
  );
};

/**
 * @summary Delete a single revision history row
 */
export const getDeleteMissionControlClueRevisionUrl = (
  id: number,
  revisionId: number,
) => {
  return `/api/mission-control/clues/${id}/revisions/${revisionId}`;
};

export const deleteMissionControlClueRevision = async (
  id: number,
  revisionId: number,
  options?: RequestInit,
): Promise<DeleteMissionControlClueRevision200> => {
  return customFetch<DeleteMissionControlClueRevision200>(
    getDeleteMissionControlClueRevisionUrl(id, revisionId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteMissionControlClueRevisionMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMissionControlClueRevision>>,
    TError,
    { id: number; revisionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMissionControlClueRevision>>,
  TError,
  { id: number; revisionId: number },
  TContext
> => {
  const mutationKey = ["deleteMissionControlClueRevision"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMissionControlClueRevision>>,
    { id: number; revisionId: number }
  > = (props) => {
    const { id, revisionId } = props ?? {};

    return deleteMissionControlClueRevision(id, revisionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMissionControlClueRevisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMissionControlClueRevision>>
>;

export type DeleteMissionControlClueRevisionMutationError =
  ErrorType<ErrorEnvelope>;

/**
 * @summary Delete a single revision history row
 */
export const useDeleteMissionControlClueRevision = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMissionControlClueRevision>>,
    TError,
    { id: number; revisionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMissionControlClueRevision>>,
  TError,
  { id: number; revisionId: number },
  TContext
> => {
  return useMutation(
    getDeleteMissionControlClueRevisionMutationOptions(options),
  );
};

/**
 * @summary Revert a clue to a prior revision snapshot
 */
export const getRevertMissionControlClueRevisionUrl = (
  id: number,
  revisionId: number,
) => {
  return `/api/mission-control/clues/${id}/revisions/${revisionId}/revert`;
};

export const revertMissionControlClueRevision = async (
  id: number,
  revisionId: number,
  options?: RequestInit,
): Promise<AdminClueRow> => {
  return customFetch<AdminClueRow>(
    getRevertMissionControlClueRevisionUrl(id, revisionId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRevertMissionControlClueRevisionMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertMissionControlClueRevision>>,
    TError,
    { id: number; revisionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revertMissionControlClueRevision>>,
  TError,
  { id: number; revisionId: number },
  TContext
> => {
  const mutationKey = ["revertMissionControlClueRevision"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revertMissionControlClueRevision>>,
    { id: number; revisionId: number }
  > = (props) => {
    const { id, revisionId } = props ?? {};

    return revertMissionControlClueRevision(id, revisionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevertMissionControlClueRevisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof revertMissionControlClueRevision>>
>;

export type RevertMissionControlClueRevisionMutationError =
  ErrorType<ErrorEnvelope>;

/**
 * @summary Revert a clue to a prior revision snapshot
 */
export const useRevertMissionControlClueRevision = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertMissionControlClueRevision>>,
    TError,
    { id: number; revisionId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revertMissionControlClueRevision>>,
  TError,
  { id: number; revisionId: number },
  TContext
> => {
  return useMutation(
    getRevertMissionControlClueRevisionMutationOptions(options),
  );
};

/**
 * @summary Approve every draft AI clue and archive unplayed starter clues
 */
export const getApproveAllMissionControlCluesUrl = () => {
  return `/api/mission-control/approve-all`;
};

export const approveAllMissionControlClues = async (
  options?: RequestInit,
): Promise<ApproveAllMissionControlClues200> => {
  return customFetch<ApproveAllMissionControlClues200>(
    getApproveAllMissionControlCluesUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getApproveAllMissionControlCluesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveAllMissionControlClues>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveAllMissionControlClues>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["approveAllMissionControlClues"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveAllMissionControlClues>>,
    void
  > = () => {
    return approveAllMissionControlClues(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveAllMissionControlCluesMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveAllMissionControlClues>>
>;

export type ApproveAllMissionControlCluesMutationError = ErrorType<unknown>;

/**
 * @summary Approve every draft AI clue and archive unplayed starter clues
 */
export const useApproveAllMissionControlClues = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveAllMissionControlClues>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveAllMissionControlClues>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getApproveAllMissionControlCluesMutationOptions(options));
};

/**
 * @summary Discard the current AI draft and keep the starter mission
 */
export const getUseMissionControlStarterUrl = () => {
  return `/api/mission-control/use-starter`;
};

export const useMissionControlStarter = async (
  options?: RequestInit,
): Promise<UseMissionControlStarter200> => {
  return customFetch<UseMissionControlStarter200>(
    getUseMissionControlStarterUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getUseMissionControlStarterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof useMissionControlStarter>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof useMissionControlStarter>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["useMissionControlStarter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof useMissionControlStarter>>,
    void
  > = () => {
    return useMissionControlStarter(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UseMissionControlStarterMutationResult = NonNullable<
  Awaited<ReturnType<typeof useMissionControlStarter>>
>;

export type UseMissionControlStarterMutationError = ErrorType<unknown>;

/**
 * @summary Discard the current AI draft and keep the starter mission
 */
export const useUseMissionControlStarter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof useMissionControlStarter>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof useMissionControlStarter>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getUseMissionControlStarterMutationOptions(options));
};

/**
 * @summary Edit the host narrative bundle for the active mission
 */
export const getEditMissionControlNarrativeUrl = () => {
  return `/api/mission-control/narrative`;
};

export const editMissionControlNarrative = async (
  editNarrativeBody: EditNarrativeBody,
  options?: RequestInit,
): Promise<EditMissionControlNarrative200> => {
  return customFetch<EditMissionControlNarrative200>(
    getEditMissionControlNarrativeUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(editNarrativeBody),
    },
  );
};

export const getEditMissionControlNarrativeMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editMissionControlNarrative>>,
    TError,
    { data: BodyType<EditNarrativeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editMissionControlNarrative>>,
  TError,
  { data: BodyType<EditNarrativeBody> },
  TContext
> => {
  const mutationKey = ["editMissionControlNarrative"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editMissionControlNarrative>>,
    { data: BodyType<EditNarrativeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return editMissionControlNarrative(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditMissionControlNarrativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof editMissionControlNarrative>>
>;
export type EditMissionControlNarrativeMutationBody =
  BodyType<EditNarrativeBody>;
export type EditMissionControlNarrativeMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Edit the host narrative bundle for the active mission
 */
export const useEditMissionControlNarrative = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editMissionControlNarrative>>,
    TError,
    { data: BodyType<EditNarrativeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof editMissionControlNarrative>>,
  TError,
  { data: BodyType<EditNarrativeBody> },
  TContext
> => {
  return useMutation(getEditMissionControlNarrativeMutationOptions(options));
};

/**
 * @summary Set or clear the active mission's story arc slug
 */
export const getEditMissionControlStoryPackUrl = () => {
  return `/api/mission-control/story-pack`;
};

export const editMissionControlStoryPack = async (
  storyPackPatchBody: StoryPackPatchBody,
  options?: RequestInit,
): Promise<StoryPackPatchResponse> => {
  return customFetch<StoryPackPatchResponse>(
    getEditMissionControlStoryPackUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(storyPackPatchBody),
    },
  );
};

export const getEditMissionControlStoryPackMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editMissionControlStoryPack>>,
    TError,
    { data: BodyType<StoryPackPatchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editMissionControlStoryPack>>,
  TError,
  { data: BodyType<StoryPackPatchBody> },
  TContext
> => {
  const mutationKey = ["editMissionControlStoryPack"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editMissionControlStoryPack>>,
    { data: BodyType<StoryPackPatchBody> }
  > = (props) => {
    const { data } = props ?? {};

    return editMissionControlStoryPack(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditMissionControlStoryPackMutationResult = NonNullable<
  Awaited<ReturnType<typeof editMissionControlStoryPack>>
>;
export type EditMissionControlStoryPackMutationBody =
  BodyType<StoryPackPatchBody>;
export type EditMissionControlStoryPackMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Set or clear the active mission's story arc slug
 */
export const useEditMissionControlStoryPack = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editMissionControlStoryPack>>,
    TError,
    { data: BodyType<StoryPackPatchBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof editMissionControlStoryPack>>,
  TError,
  { data: BodyType<StoryPackPatchBody> },
  TContext
> => {
  return useMutation(getEditMissionControlStoryPackMutationOptions(options));
};

/**
 * @summary Generate a draft recap for the active mission
 */
export const getGenerateMissionControlRecapUrl = () => {
  return `/api/mission-control/recap/generate`;
};

export const generateMissionControlRecap = async (
  options?: RequestInit,
): Promise<GenerateMissionControlRecap201> => {
  return customFetch<GenerateMissionControlRecap201>(
    getGenerateMissionControlRecapUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getGenerateMissionControlRecapMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMissionControlRecap>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateMissionControlRecap>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["generateMissionControlRecap"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateMissionControlRecap>>,
    void
  > = () => {
    return generateMissionControlRecap(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateMissionControlRecapMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateMissionControlRecap>>
>;

export type GenerateMissionControlRecapMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Generate a draft recap for the active mission
 */
export const useGenerateMissionControlRecap = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateMissionControlRecap>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateMissionControlRecap>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getGenerateMissionControlRecapMutationOptions(options));
};

/**
 * @summary Promote the latest draft recap to published
 */
export const getPublishMissionControlRecapUrl = () => {
  return `/api/mission-control/recap/publish`;
};

export const publishMissionControlRecap = async (
  options?: RequestInit,
): Promise<PublishMissionControlRecap200> => {
  return customFetch<PublishMissionControlRecap200>(
    getPublishMissionControlRecapUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPublishMissionControlRecapMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishMissionControlRecap>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishMissionControlRecap>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["publishMissionControlRecap"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishMissionControlRecap>>,
    void
  > = () => {
    return publishMissionControlRecap(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishMissionControlRecapMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishMissionControlRecap>>
>;

export type PublishMissionControlRecapMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Promote the latest draft recap to published
 */
export const usePublishMissionControlRecap = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishMissionControlRecap>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof publishMissionControlRecap>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPublishMissionControlRecapMutationOptions(options));
};

/**
 * @summary Pull the currently-published recap off the family page
 */
export const getArchiveMissionControlRecapUrl = () => {
  return `/api/mission-control/recap/archive`;
};

export const archiveMissionControlRecap = async (
  options?: RequestInit,
): Promise<ArchiveMissionControlRecap200> => {
  return customFetch<ArchiveMissionControlRecap200>(
    getArchiveMissionControlRecapUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getArchiveMissionControlRecapMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveMissionControlRecap>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveMissionControlRecap>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["archiveMissionControlRecap"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveMissionControlRecap>>,
    void
  > = () => {
    return archiveMissionControlRecap(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveMissionControlRecapMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveMissionControlRecap>>
>;

export type ArchiveMissionControlRecapMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Pull the currently-published recap off the family page
 */
export const useArchiveMissionControlRecap = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveMissionControlRecap>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveMissionControlRecap>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getArchiveMissionControlRecapMutationOptions(options));
};

/**
 * @summary Family-facing published recap for the active mission
 */
export const getGetRecapCurrentUrl = () => {
  return `/api/recap/current`;
};

export const getRecapCurrent = async (
  options?: RequestInit,
): Promise<FamilyRecapResponse> => {
  return customFetch<FamilyRecapResponse>(getGetRecapCurrentUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetRecapCurrentQueryKey = () => {
  return [`/api/recap/current`] as const;
};

export const getGetRecapCurrentQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecapCurrent>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getRecapCurrent>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecapCurrentQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecapCurrent>>> = ({
    signal,
  }) => getRecapCurrent({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecapCurrent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecapCurrentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecapCurrent>>
>;
export type GetRecapCurrentQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Family-facing published recap for the active mission
 */

export function useGetRecapCurrent<
  TData = Awaited<ReturnType<typeof getRecapCurrent>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getRecapCurrent>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecapCurrentQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Host-only. Records a short (≤280 char) plain-text announcement
for the host's active mission. The announcement appears in the
Fireplace Feed for every team in the family within ≤5 s (the
hub aggregation polls on that cadence). Players (role=player)
receive 403.

Tenant + mission are derived server-side from the session — the
client never supplies them. Each call also writes a
host_announcement_posted row to admin_audit_events.

 * @summary Host posts a short announcement to the Fireplace Feed
 */
export const getPostHostAnnouncementUrl = () => {
  return `/api/hub/announcements`;
};

export const postHostAnnouncement = async (
  hostAnnouncementCreateRequest: HostAnnouncementCreateRequest,
  options?: RequestInit,
): Promise<HubFeedItem> => {
  return customFetch<HubFeedItem>(getPostHostAnnouncementUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(hostAnnouncementCreateRequest),
  });
};

export const getPostHostAnnouncementMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postHostAnnouncement>>,
    TError,
    { data: BodyType<HostAnnouncementCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postHostAnnouncement>>,
  TError,
  { data: BodyType<HostAnnouncementCreateRequest> },
  TContext
> => {
  const mutationKey = ["postHostAnnouncement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postHostAnnouncement>>,
    { data: BodyType<HostAnnouncementCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postHostAnnouncement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostHostAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof postHostAnnouncement>>
>;
export type PostHostAnnouncementMutationBody =
  BodyType<HostAnnouncementCreateRequest>;
export type PostHostAnnouncementMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Host posts a short announcement to the Fireplace Feed
 */
export const usePostHostAnnouncement = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postHostAnnouncement>>,
    TError,
    { data: BodyType<HostAnnouncementCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postHostAnnouncement>>,
  TError,
  { data: BodyType<HostAnnouncementCreateRequest> },
  TContext
> => {
  return useMutation(getPostHostAnnouncementMutationOptions(options));
};

/**
 * Host-only. Soft-deletes an announcement the host previously posted
in the active mission. Tenant + mission scoped server-side; a host
cannot delete announcements from another family. Records a
host_announcement_deleted audit row.

 * @summary Host deletes one of their own announcements
 */
export const getDeleteHostAnnouncementUrl = (announcementId: number) => {
  return `/api/hub/announcements/${announcementId}`;
};

export const deleteHostAnnouncement = async (
  announcementId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteHostAnnouncementUrl(announcementId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteHostAnnouncementMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHostAnnouncement>>,
    TError,
    { announcementId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteHostAnnouncement>>,
  TError,
  { announcementId: number },
  TContext
> => {
  const mutationKey = ["deleteHostAnnouncement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteHostAnnouncement>>,
    { announcementId: number }
  > = (props) => {
    const { announcementId } = props ?? {};

    return deleteHostAnnouncement(announcementId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteHostAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteHostAnnouncement>>
>;

export type DeleteHostAnnouncementMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Host deletes one of their own announcements
 */
export const useDeleteHostAnnouncement = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHostAnnouncement>>,
    TError,
    { announcementId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteHostAnnouncement>>,
  TError,
  { announcementId: number },
  TContext
> => {
  return useMutation(getDeleteHostAnnouncementMutationOptions(options));
};

/**
 * Returns the full payload for the Christmas Hub v1 home page:
hero (family/mission name, day, sleigh countdown), deterministic
Daily Magic content key, the last 5 Fireplace Feed messages from
the elf inbox, Memory Shelf links (recap gated on published status),
an Activity Snapshot (finds, clues, unread counts), and (when the
active mission has a story pack selected) the current story
chapter for today's game day.

All data is scoped server-side via session + tenant + mission — the
client never supplies IDs. Photo URLs are returned through the gated
/api/storage/objects/* route; raw object paths never appear in the
response. Draft clue text, host-only narrative fields, and invite
codes are excluded.

 * @summary Family Fireplace aggregation for the signed-in player's active mission
 */
export const getGetHubCurrentUrl = (params?: GetHubCurrentParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/hub/current?${stringifiedParams}`
    : `/api/hub/current`;
};

export const getHubCurrent = async (
  params?: GetHubCurrentParams,
  options?: RequestInit,
): Promise<HubCurrent> => {
  return customFetch<HubCurrent>(getGetHubCurrentUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetHubCurrentQueryKey = (params?: GetHubCurrentParams) => {
  return [`/api/hub/current`, ...(params ? [params] : [])] as const;
};

export const getGetHubCurrentQueryOptions = <
  TData = Awaited<ReturnType<typeof getHubCurrent>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  params?: GetHubCurrentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHubCurrent>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHubCurrentQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHubCurrent>>> = ({
    signal,
  }) => getHubCurrent(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHubCurrent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHubCurrentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHubCurrent>>
>;
export type GetHubCurrentQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Family Fireplace aggregation for the signed-in player's active mission
 */

export function useGetHubCurrent<
  TData = Awaited<ReturnType<typeof getHubCurrent>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  params?: GetHubCurrentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHubCurrent>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetHubCurrentQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the server's VAPID public key. Safe to expose publicly. Returns configured=false when VAPID is not set up.
 * @summary Get the VAPID public key (unauthenticated)
 */
export const getGetNotificationPushPublicKeyUrl = () => {
  return `/api/notifications/push/public-key`;
};

export const getNotificationPushPublicKey = async (
  options?: RequestInit,
): Promise<GetNotificationPushPublicKey200> => {
  return customFetch<GetNotificationPushPublicKey200>(
    getGetNotificationPushPublicKeyUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNotificationPushPublicKeyQueryKey = () => {
  return [`/api/notifications/push/public-key`] as const;
};

export const getGetNotificationPushPublicKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationPushPublicKey>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPushPublicKey>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotificationPushPublicKeyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationPushPublicKey>>
  > = ({ signal }) =>
    getNotificationPushPublicKey({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPushPublicKey>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationPushPublicKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationPushPublicKey>>
>;
export type GetNotificationPushPublicKeyQueryError = ErrorType<unknown>;

/**
 * @summary Get the VAPID public key (unauthenticated)
 */

export function useGetNotificationPushPublicKey<
  TData = Awaited<ReturnType<typeof getNotificationPushPublicKey>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPushPublicKey>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationPushPublicKeyQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the signed-in user's notification preferences
 */
export const getGetNotificationPreferencesUrl = () => {
  return `/api/notifications/preferences`;
};

export const getNotificationPreferences = async (
  options?: RequestInit,
): Promise<NotificationPreferences> => {
  return customFetch<NotificationPreferences>(
    getGetNotificationPreferencesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNotificationPreferencesQueryKey = () => {
  return [`/api/notifications/preferences`] as const;
};

export const getGetNotificationPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationPreferences>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotificationPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationPreferences>>
  > = ({ signal }) => getNotificationPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPreferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationPreferences>>
>;
export type GetNotificationPreferencesQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Get the signed-in user's notification preferences
 */

export function useGetNotificationPreferences<
  TData = Awaited<ReturnType<typeof getNotificationPreferences>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationPreferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the signed-in user's notification preferences
 */
export const getUpdateNotificationPreferencesUrl = () => {
  return `/api/notifications/preferences`;
};

export const updateNotificationPreferences = async (
  updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest,
  options?: RequestInit,
): Promise<NotificationPreferences> => {
  return customFetch<NotificationPreferences>(
    getUpdateNotificationPreferencesUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateNotificationPreferencesRequest),
    },
  );
};

export const getUpdateNotificationPreferencesMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    TError,
    { data: BodyType<UpdateNotificationPreferencesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationPreferences>>,
  TError,
  { data: BodyType<UpdateNotificationPreferencesRequest> },
  TContext
> => {
  const mutationKey = ["updateNotificationPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    { data: BodyType<UpdateNotificationPreferencesRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateNotificationPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationPreferences>>
>;
export type UpdateNotificationPreferencesMutationBody =
  BodyType<UpdateNotificationPreferencesRequest>;
export type UpdateNotificationPreferencesMutationError =
  ErrorType<ErrorEnvelope>;

/**
 * @summary Update the signed-in user's notification preferences
 */
export const useUpdateNotificationPreferences = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationPreferences>>,
    TError,
    { data: BodyType<UpdateNotificationPreferencesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationPreferences>>,
  TError,
  { data: BodyType<UpdateNotificationPreferencesRequest> },
  TContext
> => {
  return useMutation(getUpdateNotificationPreferencesMutationOptions(options));
};

/**
 * Stores the Web Push subscription server-side and enables pushEnabled in preferences.
endpoint, p256dh, and auth are NEVER returned to any client response.

 * @summary Register a Web Push subscription for this browser/device
 */
export const getSubscribePushUrl = () => {
  return `/api/notifications/push/subscribe`;
};

export const subscribePush = async (
  pushSubscribeRequest: PushSubscribeRequest,
  options?: RequestInit,
): Promise<SubscribePush201> => {
  return customFetch<SubscribePush201>(getSubscribePushUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(pushSubscribeRequest),
  });
};

export const getSubscribePushMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribePush>>,
    TError,
    { data: BodyType<PushSubscribeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof subscribePush>>,
  TError,
  { data: BodyType<PushSubscribeRequest> },
  TContext
> => {
  const mutationKey = ["subscribePush"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof subscribePush>>,
    { data: BodyType<PushSubscribeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return subscribePush(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubscribePushMutationResult = NonNullable<
  Awaited<ReturnType<typeof subscribePush>>
>;
export type SubscribePushMutationBody = BodyType<PushSubscribeRequest>;
export type SubscribePushMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Register a Web Push subscription for this browser/device
 */
export const useSubscribePush = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribePush>>,
    TError,
    { data: BodyType<PushSubscribeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof subscribePush>>,
  TError,
  { data: BodyType<PushSubscribeRequest> },
  TContext
> => {
  return useMutation(getSubscribePushMutationOptions(options));
};

/**
 * @summary Revoke a Web Push subscription
 */
export const getUnsubscribePushUrl = () => {
  return `/api/notifications/push/unsubscribe`;
};

export const unsubscribePush = async (
  unsubscribePushRequest: UnsubscribePushRequest,
  options?: RequestInit,
): Promise<UnsubscribePush200> => {
  return customFetch<UnsubscribePush200>(getUnsubscribePushUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(unsubscribePushRequest),
  });
};

export const getUnsubscribePushMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unsubscribePush>>,
    TError,
    { data: BodyType<UnsubscribePushRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unsubscribePush>>,
  TError,
  { data: BodyType<UnsubscribePushRequest> },
  TContext
> => {
  const mutationKey = ["unsubscribePush"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unsubscribePush>>,
    { data: BodyType<UnsubscribePushRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return unsubscribePush(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnsubscribePushMutationResult = NonNullable<
  Awaited<ReturnType<typeof unsubscribePush>>
>;
export type UnsubscribePushMutationBody = BodyType<UnsubscribePushRequest>;
export type UnsubscribePushMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Revoke a Web Push subscription
 */
export const useUnsubscribePush = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unsubscribePush>>,
    TError,
    { data: BodyType<UnsubscribePushRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unsubscribePush>>,
  TError,
  { data: BodyType<UnsubscribePushRequest> },
  TContext
> => {
  return useMutation(getUnsubscribePushMutationOptions(options));
};

/**
 * Stores a native push device token (Apple APNs or Google FCM) server-side
and enables pushEnabled in preferences. The raw deviceToken is NEVER
returned to any client response.

 * @summary Register a native push device token (APNs / FCM)
 */
export const getSubscribePushNativeUrl = () => {
  return `/api/notifications/push/subscribe-native`;
};

export const subscribePushNative = async (
  pushSubscribeNativeRequest: PushSubscribeNativeRequest,
  options?: RequestInit,
): Promise<SubscribePushNative201> => {
  return customFetch<SubscribePushNative201>(getSubscribePushNativeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(pushSubscribeNativeRequest),
  });
};

export const getSubscribePushNativeMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribePushNative>>,
    TError,
    { data: BodyType<PushSubscribeNativeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof subscribePushNative>>,
  TError,
  { data: BodyType<PushSubscribeNativeRequest> },
  TContext
> => {
  const mutationKey = ["subscribePushNative"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof subscribePushNative>>,
    { data: BodyType<PushSubscribeNativeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return subscribePushNative(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubscribePushNativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof subscribePushNative>>
>;
export type SubscribePushNativeMutationBody =
  BodyType<PushSubscribeNativeRequest>;
export type SubscribePushNativeMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Register a native push device token (APNs / FCM)
 */
export const useSubscribePushNative = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof subscribePushNative>>,
    TError,
    { data: BodyType<PushSubscribeNativeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof subscribePushNative>>,
  TError,
  { data: BodyType<PushSubscribeNativeRequest> },
  TContext
> => {
  return useMutation(getSubscribePushNativeMutationOptions(options));
};

/**
 * @summary Revoke a native push device token
 */
export const getUnsubscribePushNativeUrl = () => {
  return `/api/notifications/push/unsubscribe-native`;
};

export const unsubscribePushNative = async (
  unsubscribePushNativeRequest: UnsubscribePushNativeRequest,
  options?: RequestInit,
): Promise<UnsubscribePushNative200> => {
  return customFetch<UnsubscribePushNative200>(getUnsubscribePushNativeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(unsubscribePushNativeRequest),
  });
};

export const getUnsubscribePushNativeMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unsubscribePushNative>>,
    TError,
    { data: BodyType<UnsubscribePushNativeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unsubscribePushNative>>,
  TError,
  { data: BodyType<UnsubscribePushNativeRequest> },
  TContext
> => {
  const mutationKey = ["unsubscribePushNative"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unsubscribePushNative>>,
    { data: BodyType<UnsubscribePushNativeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return unsubscribePushNative(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnsubscribePushNativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof unsubscribePushNative>>
>;
export type UnsubscribePushNativeMutationBody =
  BodyType<UnsubscribePushNativeRequest>;
export type UnsubscribePushNativeMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Revoke a native push device token
 */
export const useUnsubscribePushNative = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unsubscribePushNative>>,
    TError,
    { data: BodyType<UnsubscribePushNativeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unsubscribePushNative>>,
  TError,
  { data: BodyType<UnsubscribePushNativeRequest> },
  TContext
> => {
  return useMutation(getUnsubscribePushNativeMutationOptions(options));
};

/**
 * @summary Send a test notification to the signed-in adult user (rate-limited 5/hr)
 */
export const getTestSendSelfUrl = () => {
  return `/api/notifications/test-send-self`;
};

export const testSendSelf = async (
  options?: RequestInit,
): Promise<TestSendSelf200> => {
  return customFetch<TestSendSelf200>(getTestSendSelfUrl(), {
    ...options,
    method: "POST",
  });
};

export const getTestSendSelfMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testSendSelf>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testSendSelf>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["testSendSelf"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testSendSelf>>,
    void
  > = () => {
    return testSendSelf(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestSendSelfMutationResult = NonNullable<
  Awaited<ReturnType<typeof testSendSelf>>
>;

export type TestSendSelfMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Send a test notification to the signed-in adult user (rate-limited 5/hr)
 */
export const useTestSendSelf = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testSendSelf>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testSendSelf>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getTestSendSelfMutationOptions(options));
};

/**
 * @summary List the signed-in user's in-app notifications (cursor-paginated)
 */
export const getListInAppNotificationsUrl = (
  params?: ListInAppNotificationsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/notifications/in-app?${stringifiedParams}`
    : `/api/notifications/in-app`;
};

export const listInAppNotifications = async (
  params?: ListInAppNotificationsParams,
  options?: RequestInit,
): Promise<InAppNotificationList> => {
  return customFetch<InAppNotificationList>(
    getListInAppNotificationsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListInAppNotificationsQueryKey = (
  params?: ListInAppNotificationsParams,
) => {
  return [`/api/notifications/in-app`, ...(params ? [params] : [])] as const;
};

export const getListInAppNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInAppNotifications>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  params?: ListInAppNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInAppNotifications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInAppNotificationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInAppNotifications>>
  > = ({ signal }) =>
    listInAppNotifications(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInAppNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInAppNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInAppNotifications>>
>;
export type ListInAppNotificationsQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary List the signed-in user's in-app notifications (cursor-paginated)
 */

export function useListInAppNotifications<
  TData = Awaited<ReturnType<typeof listInAppNotifications>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  params?: ListInAppNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInAppNotifications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInAppNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark a single in-app notification as read
 */
export const getMarkInAppNotificationReadUrl = (id: number) => {
  return `/api/notifications/in-app/${id}/read`;
};

export const markInAppNotificationRead = async (
  id: number,
  options?: RequestInit,
): Promise<InAppNotification> => {
  return customFetch<InAppNotification>(getMarkInAppNotificationReadUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getMarkInAppNotificationReadMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markInAppNotificationRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markInAppNotificationRead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["markInAppNotificationRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markInAppNotificationRead>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return markInAppNotificationRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkInAppNotificationReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markInAppNotificationRead>>
>;

export type MarkInAppNotificationReadMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Mark a single in-app notification as read
 */
export const useMarkInAppNotificationRead = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markInAppNotificationRead>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markInAppNotificationRead>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getMarkInAppNotificationReadMutationOptions(options));
};

/**
 * @summary Mark all unread in-app notifications as read for the current user
 */
export const getMarkAllInAppNotificationsReadUrl = () => {
  return `/api/notifications/in-app/read-all`;
};

export const markAllInAppNotificationsRead = async (
  options?: RequestInit,
): Promise<MarkAllInAppNotificationsRead200> => {
  return customFetch<MarkAllInAppNotificationsRead200>(
    getMarkAllInAppNotificationsReadUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getMarkAllInAppNotificationsReadMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllInAppNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAllInAppNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["markAllInAppNotificationsRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAllInAppNotificationsRead>>,
    void
  > = () => {
    return markAllInAppNotificationsRead(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllInAppNotificationsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAllInAppNotificationsRead>>
>;

export type MarkAllInAppNotificationsReadMutationError =
  ErrorType<ErrorEnvelope>;

/**
 * @summary Mark all unread in-app notifications as read for the current user
 */
export const useMarkAllInAppNotificationsRead = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllInAppNotificationsRead>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markAllInAppNotificationsRead>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getMarkAllInAppNotificationsReadMutationOptions(options));
};

/**
 * Adult roles [owner, admin, player] only. child role returns 403.
Hosts see all claims; non-hosts see only their own claims.
privateNote is returned only to the claimant or hosts.

 * @summary List gift claims visible to the current user
 */
export const getListGiftClaimsUrl = () => {
  return `/api/gift-workshop/claims`;
};

export const listGiftClaims = async (
  options?: RequestInit,
): Promise<GiftClaimWithWish[]> => {
  return customFetch<GiftClaimWithWish[]>(getListGiftClaimsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListGiftClaimsQueryKey = () => {
  return [`/api/gift-workshop/claims`] as const;
};

export const getListGiftClaimsQueryOptions = <
  TData = Awaited<ReturnType<typeof listGiftClaims>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listGiftClaims>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGiftClaimsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGiftClaims>>> = ({
    signal,
  }) => listGiftClaims({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGiftClaims>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGiftClaimsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGiftClaims>>
>;
export type ListGiftClaimsQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary List gift claims visible to the current user
 */

export function useListGiftClaims<
  TData = Awaited<ReturnType<typeof listGiftClaims>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listGiftClaims>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListGiftClaimsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates an active gift claim. Blocks self-claiming. Returns 409 if an
active claim already exists unless hostOverrideDuplicate=true and caller is a host.

 * @summary Claim a family member's wish
 */
export const getCreateGiftClaimUrl = () => {
  return `/api/gift-workshop/claims`;
};

export const createGiftClaim = async (
  createGiftClaimRequest: CreateGiftClaimRequest,
  options?: RequestInit,
): Promise<GiftClaim> => {
  return customFetch<GiftClaim>(getCreateGiftClaimUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createGiftClaimRequest),
  });
};

export const getCreateGiftClaimMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGiftClaim>>,
    TError,
    { data: BodyType<CreateGiftClaimRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGiftClaim>>,
  TError,
  { data: BodyType<CreateGiftClaimRequest> },
  TContext
> => {
  const mutationKey = ["createGiftClaim"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGiftClaim>>,
    { data: BodyType<CreateGiftClaimRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createGiftClaim(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGiftClaimMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGiftClaim>>
>;
export type CreateGiftClaimMutationBody = BodyType<CreateGiftClaimRequest>;
export type CreateGiftClaimMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Claim a family member's wish
 */
export const useCreateGiftClaim = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGiftClaim>>,
    TError,
    { data: BodyType<CreateGiftClaimRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGiftClaim>>,
  TError,
  { data: BodyType<CreateGiftClaimRequest> },
  TContext
> => {
  return useMutation(getCreateGiftClaimMutationOptions(options));
};

/**
 * @summary Update a gift claim's status or private note
 */
export const getUpdateGiftClaimUrl = (id: number) => {
  return `/api/gift-workshop/claims/${id}`;
};

export const updateGiftClaim = async (
  id: number,
  updateGiftClaimRequest: UpdateGiftClaimRequest,
  options?: RequestInit,
): Promise<GiftClaim> => {
  return customFetch<GiftClaim>(getUpdateGiftClaimUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateGiftClaimRequest),
  });
};

export const getUpdateGiftClaimMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGiftClaim>>,
    TError,
    { id: number; data: BodyType<UpdateGiftClaimRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGiftClaim>>,
  TError,
  { id: number; data: BodyType<UpdateGiftClaimRequest> },
  TContext
> => {
  const mutationKey = ["updateGiftClaim"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGiftClaim>>,
    { id: number; data: BodyType<UpdateGiftClaimRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGiftClaim(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGiftClaimMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGiftClaim>>
>;
export type UpdateGiftClaimMutationBody = BodyType<UpdateGiftClaimRequest>;
export type UpdateGiftClaimMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Update a gift claim's status or private note
 */
export const useUpdateGiftClaim = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGiftClaim>>,
    TError,
    { id: number; data: BodyType<UpdateGiftClaimRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGiftClaim>>,
  TError,
  { id: number; data: BodyType<UpdateGiftClaimRequest> },
  TContext
> => {
  return useMutation(getUpdateGiftClaimMutationOptions(options));
};

/**
 * @summary Release a gift claim (make the wish claimable again)
 */
export const getReleaseGiftClaimUrl = (id: number) => {
  return `/api/gift-workshop/claims/${id}/release`;
};

export const releaseGiftClaim = async (
  id: number,
  options?: RequestInit,
): Promise<GiftClaim> => {
  return customFetch<GiftClaim>(getReleaseGiftClaimUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getReleaseGiftClaimMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseGiftClaim>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof releaseGiftClaim>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["releaseGiftClaim"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof releaseGiftClaim>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return releaseGiftClaim(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReleaseGiftClaimMutationResult = NonNullable<
  Awaited<ReturnType<typeof releaseGiftClaim>>
>;

export type ReleaseGiftClaimMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Release a gift claim (make the wish claimable again)
 */
export const useReleaseGiftClaim = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseGiftClaim>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof releaseGiftClaim>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getReleaseGiftClaimMutationOptions(options));
};

/**
 * Returns counts of unclaimed/claimed/purchased/wrapped/ready wishes and conflict flags for owner/admin roles only.
 * @summary Host-only aggregate stats for the gift workshop
 */
export const getGetGiftWorkshopOverviewUrl = () => {
  return `/api/gift-workshop/overview`;
};

export const getGiftWorkshopOverview = async (
  options?: RequestInit,
): Promise<GiftWorkshopOverview> => {
  return customFetch<GiftWorkshopOverview>(getGetGiftWorkshopOverviewUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGiftWorkshopOverviewQueryKey = () => {
  return [`/api/gift-workshop/overview`] as const;
};

export const getGetGiftWorkshopOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getGiftWorkshopOverview>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGiftWorkshopOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGiftWorkshopOverviewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGiftWorkshopOverview>>
  > = ({ signal }) => getGiftWorkshopOverview({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGiftWorkshopOverview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGiftWorkshopOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGiftWorkshopOverview>>
>;
export type GetGiftWorkshopOverviewQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Host-only aggregate stats for the gift workshop
 */

export function useGetGiftWorkshopOverview<
  TData = Awaited<ReturnType<typeof getGiftWorkshopOverview>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGiftWorkshopOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGiftWorkshopOverviewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all wishes owned by the current user in the active tenant,
ordered by sortOrder ascending then createdAt descending. Active
wishes (archivedAt IS NULL) are returned by default. Pass
`?includeArchived=true` to also include archived rows so the owner
can review their full history.

Tenant is always resolved server-side from the session — clients
never supply tenantId.

 * @summary List the signed-in user's own wishes
 */
export const getListMyWishesUrl = (params?: ListMyWishesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/wish-list/mine?${stringifiedParams}`
    : `/api/wish-list/mine`;
};

export const listMyWishes = async (
  params?: ListMyWishesParams,
  options?: RequestInit,
): Promise<Wish[]> => {
  return customFetch<Wish[]>(getListMyWishesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMyWishesQueryKey = (params?: ListMyWishesParams) => {
  return [`/api/wish-list/mine`, ...(params ? [params] : [])] as const;
};

export const getListMyWishesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyWishes>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  params?: ListMyWishesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMyWishes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyWishesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyWishes>>> = ({
    signal,
  }) => listMyWishes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyWishes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMyWishesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyWishes>>
>;
export type ListMyWishesQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary List the signed-in user's own wishes
 */

export function useListMyWishes<
  TData = Awaited<ReturnType<typeof listMyWishes>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  params?: ListMyWishesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMyWishes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMyWishesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns every active (non-revoked) member of the current tenant, each
with their non-archived wish list. Read-only for all roles including
child. Tenant is resolved server-side from the session.

 * @summary List all active family members with their non-archived wishes
 */
export const getListFamilyWishesUrl = () => {
  return `/api/wish-list/family`;
};

export const listFamilyWishes = async (
  options?: RequestInit,
): Promise<MemberWishList[]> => {
  return customFetch<MemberWishList[]>(getListFamilyWishesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListFamilyWishesQueryKey = () => {
  return [`/api/wish-list/family`] as const;
};

export const getListFamilyWishesQueryOptions = <
  TData = Awaited<ReturnType<typeof listFamilyWishes>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listFamilyWishes>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFamilyWishesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFamilyWishes>>
  > = ({ signal }) => listFamilyWishes({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFamilyWishes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFamilyWishesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFamilyWishes>>
>;
export type ListFamilyWishesQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary List all active family members with their non-archived wishes
 */

export function useListFamilyWishes<
  TData = Awaited<ReturnType<typeof listFamilyWishes>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listFamilyWishes>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFamilyWishesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add a wish to the signed-in user's Christmas list
 */
export const getCreateWishUrl = () => {
  return `/api/wish-list/wishes`;
};

export const createWish = async (
  createWishRequest: CreateWishRequest,
  options?: RequestInit,
): Promise<Wish> => {
  return customFetch<Wish>(getCreateWishUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createWishRequest),
  });
};

export const getCreateWishMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWish>>,
    TError,
    { data: BodyType<CreateWishRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWish>>,
  TError,
  { data: BodyType<CreateWishRequest> },
  TContext
> => {
  const mutationKey = ["createWish"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWish>>,
    { data: BodyType<CreateWishRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createWish(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWishMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWish>>
>;
export type CreateWishMutationBody = BodyType<CreateWishRequest>;
export type CreateWishMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Add a wish to the signed-in user's Christmas list
 */
export const useCreateWish = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWish>>,
    TError,
    { data: BodyType<CreateWishRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWish>>,
  TError,
  { data: BodyType<CreateWishRequest> },
  TContext
> => {
  return useMutation(getCreateWishMutationOptions(options));
};

/**
 * Only the wish owner may mutate their wish. All fields are optional
(PATCH semantics). Cross-tenant access returns 404 to avoid existence
leaks. Updating another user's wish returns 404 (not 403) for the
same reason.

 * @summary Update a wish owned by the signed-in user
 */
export const getUpdateWishUrl = (id: number) => {
  return `/api/wish-list/wishes/${id}`;
};

export const updateWish = async (
  id: number,
  updateWishRequest: UpdateWishRequest,
  options?: RequestInit,
): Promise<Wish> => {
  return customFetch<Wish>(getUpdateWishUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateWishRequest),
  });
};

export const getUpdateWishMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWish>>,
    TError,
    { id: number; data: BodyType<UpdateWishRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWish>>,
  TError,
  { id: number; data: BodyType<UpdateWishRequest> },
  TContext
> => {
  const mutationKey = ["updateWish"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWish>>,
    { id: number; data: BodyType<UpdateWishRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateWish(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWishMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWish>>
>;
export type UpdateWishMutationBody = BodyType<UpdateWishRequest>;
export type UpdateWishMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Update a wish owned by the signed-in user
 */
export const useUpdateWish = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWish>>,
    TError,
    { id: number; data: BodyType<UpdateWishRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWish>>,
  TError,
  { id: number; data: BodyType<UpdateWishRequest> },
  TContext
> => {
  return useMutation(getUpdateWishMutationOptions(options));
};

/**
 * Sets archivedAt to the current timestamp. Only the wish owner may
archive their own wish. Cross-tenant and cross-owner access both
return 404.

 * @summary Archive a wish owned by the signed-in user
 */
export const getArchiveWishUrl = (id: number) => {
  return `/api/wish-list/wishes/${id}/archive`;
};

export const archiveWish = async (
  id: number,
  options?: RequestInit,
): Promise<Wish> => {
  return customFetch<Wish>(getArchiveWishUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getArchiveWishMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveWish>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveWish>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["archiveWish"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveWish>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return archiveWish(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveWishMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveWish>>
>;

export type ArchiveWishMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Archive a wish owned by the signed-in user
 */
export const useArchiveWish = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveWish>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveWish>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getArchiveWishMutationOptions(options));
};

/**
 * Returns the non-archived wishes belonging to a single family member.
The member must be an active (non-revoked) participant of the caller's
tenant — otherwise the server returns 404 so the API never leaks
whether a userId exists in another family's data.

 * @summary View one family member's wish list (read-only)
 */
export const getListMemberWishesUrl = (userId: number) => {
  return `/api/wish-list/members/${userId}`;
};

export const listMemberWishes = async (
  userId: number,
  options?: RequestInit,
): Promise<Wish[]> => {
  return customFetch<Wish[]>(getListMemberWishesUrl(userId), {
    ...options,
    method: "GET",
  });
};

export const getListMemberWishesQueryKey = (userId: number) => {
  return [`/api/wish-list/members/${userId}`] as const;
};

export const getListMemberWishesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMemberWishes>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  userId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMemberWishes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMemberWishesQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMemberWishes>>
  > = ({ signal }) => listMemberWishes(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMemberWishes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMemberWishesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMemberWishes>>
>;
export type ListMemberWishesQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary View one family member's wish list (read-only)
 */

export function useListMemberWishes<
  TData = Awaited<ReturnType<typeof listMemberWishes>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  userId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMemberWishes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMemberWishesQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Owner/admin only. Returns every active family member with their
non-archived wishes, including host-only planning fields
(purchasedAt, wrappedAt, budgetCents) and a budget summary that
compares estimated total spend (sum of budgetCents) against
actual spend (sum of budgetCents on wishes whose purchasedAt is
set). Children and players cannot reach this endpoint — the
server returns 403.

 * @summary Admin Gift Workshop — every family member's wishes with host-only fields
 */
export const getGetGiftWorkshopUrl = () => {
  return `/api/wish-list/workshop`;
};

export const getGiftWorkshop = async (
  options?: RequestInit,
): Promise<GiftWorkshopState> => {
  return customFetch<GiftWorkshopState>(getGetGiftWorkshopUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGiftWorkshopQueryKey = () => {
  return [`/api/wish-list/workshop`] as const;
};

export const getGetGiftWorkshopQueryOptions = <
  TData = Awaited<ReturnType<typeof getGiftWorkshop>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGiftWorkshop>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGiftWorkshopQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGiftWorkshop>>> = ({
    signal,
  }) => getGiftWorkshop({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGiftWorkshop>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGiftWorkshopQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGiftWorkshop>>
>;
export type GetGiftWorkshopQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Admin Gift Workshop — every family member's wishes with host-only fields
 */

export function useGetGiftWorkshop<
  TData = Awaited<ReturnType<typeof getGiftWorkshop>>,
  TError = ErrorType<ErrorEnvelope>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGiftWorkshop>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGiftWorkshopQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Owner/admin only. Toggles purchased / wrapped state and sets the
per-wish estimated budget (in integer cents). Sending
`purchased: false` or `wrapped: false` clears the corresponding
timestamp; sending `true` stamps it to the current time.
Sending `budgetCents: null` clears the budget.

Cross-tenant access returns 404. Children and players are
rejected with 403.

 * @summary Admin update of a wish's host-only workshop fields
 */
export const getUpdateWorkshopWishUrl = (id: number) => {
  return `/api/wish-list/wishes/${id}/workshop`;
};

export const updateWorkshopWish = async (
  id: number,
  updateWorkshopWishRequest: UpdateWorkshopWishRequest,
  options?: RequestInit,
): Promise<Wish> => {
  return customFetch<Wish>(getUpdateWorkshopWishUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateWorkshopWishRequest),
  });
};

export const getUpdateWorkshopWishMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkshopWish>>,
    TError,
    { id: number; data: BodyType<UpdateWorkshopWishRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWorkshopWish>>,
  TError,
  { id: number; data: BodyType<UpdateWorkshopWishRequest> },
  TContext
> => {
  const mutationKey = ["updateWorkshopWish"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWorkshopWish>>,
    { id: number; data: BodyType<UpdateWorkshopWishRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateWorkshopWish(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWorkshopWishMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWorkshopWish>>
>;
export type UpdateWorkshopWishMutationBody =
  BodyType<UpdateWorkshopWishRequest>;
export type UpdateWorkshopWishMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Admin update of a wish's host-only workshop fields
 */
export const useUpdateWorkshopWish = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkshopWish>>,
    TError,
    { id: number; data: BodyType<UpdateWorkshopWishRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWorkshopWish>>,
  TError,
  { id: number; data: BodyType<UpdateWorkshopWishRequest> },
  TContext
> => {
  return useMutation(getUpdateWorkshopWishMutationOptions(options));
};

/**
 * Marks a wish on another family member's list as "I'm buying this one"
so two adults don't end up doubling up on the same gift. Only
non-child members of the tenant may claim. The wish's owner can
never see who (or whether anyone) claimed their wish — claim status
is hidden from the owner everywhere in the API to keep it a
surprise. A wish that is already claimed by someone else returns
409. Claiming your own wish or an archived/missing wish returns
404 (existence is never leaked across tenants).

 * @summary Claim a family member's wish (Gift Magic v2)
 */
export const getClaimWishUrl = (id: number) => {
  return `/api/wish-list/wishes/${id}/claim`;
};

export const claimWish = async (
  id: number,
  options?: RequestInit,
): Promise<Wish> => {
  return customFetch<Wish>(getClaimWishUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getClaimWishMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimWish>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof claimWish>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["claimWish"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof claimWish>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return claimWish(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClaimWishMutationResult = NonNullable<
  Awaited<ReturnType<typeof claimWish>>
>;

export type ClaimWishMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Claim a family member's wish (Gift Magic v2)
 */
export const useClaimWish = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimWish>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof claimWish>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getClaimWishMutationOptions(options));
};

/**
 * Clears the claim on a wish that the signed-in user previously
claimed. If plans change and someone else should buy it, the
claimer unclaims and the wish becomes available again.

Only the user who originally made the claim may unclaim — other
family members get 404 (not 403) so the existence of the claim
doesn't leak to non-claimers. The owner of the wish never sees
the claim, so calling unclaim on their own wish always returns
404.

 * @summary Release a claim you previously made on a wish
 */
export const getUnclaimWishUrl = (id: number) => {
  return `/api/wish-list/wishes/${id}/unclaim`;
};

export const unclaimWish = async (
  id: number,
  options?: RequestInit,
): Promise<Wish> => {
  return customFetch<Wish>(getUnclaimWishUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getUnclaimWishMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unclaimWish>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unclaimWish>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["unclaimWish"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unclaimWish>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return unclaimWish(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnclaimWishMutationResult = NonNullable<
  Awaited<ReturnType<typeof unclaimWish>>
>;

export type UnclaimWishMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Release a claim you previously made on a wish
 */
export const useUnclaimWish = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unclaimWish>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unclaimWish>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getUnclaimWishMutationOptions(options));
};

/**
 * Accepts an ordered array of wish IDs. The server assigns sortOrder
0, 1, 2, … in the given order. Only wishes owned by the current user
in the active tenant are accepted — any ID that does not belong to
the caller is silently skipped (404 is not returned) so the client
does not need to handle partial failures.

 * @summary Update sortOrder for one or more of the signed-in user's wishes
 */
export const getReorderWishesUrl = () => {
  return `/api/wish-list/reorder`;
};

export const reorderWishes = async (
  reorderWishesRequest: ReorderWishesRequest,
  options?: RequestInit,
): Promise<Wish[]> => {
  return customFetch<Wish[]>(getReorderWishesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reorderWishesRequest),
  });
};

export const getReorderWishesMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderWishes>>,
    TError,
    { data: BodyType<ReorderWishesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderWishes>>,
  TError,
  { data: BodyType<ReorderWishesRequest> },
  TContext
> => {
  const mutationKey = ["reorderWishes"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderWishes>>,
    { data: BodyType<ReorderWishesRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return reorderWishes(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderWishesMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderWishes>>
>;
export type ReorderWishesMutationBody = BodyType<ReorderWishesRequest>;
export type ReorderWishesMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Update sortOrder for one or more of the signed-in user's wishes
 */
export const useReorderWishes = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderWishes>>,
    TError,
    { data: BodyType<ReorderWishesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reorderWishes>>,
  TError,
  { data: BodyType<ReorderWishesRequest> },
  TContext
> => {
  return useMutation(getReorderWishesMutationOptions(options));
};
